/**
 * Bahasa Indonesia.
 *
 * Kuncinya berasal dari `cs.js`. Kalau ada yang hilang, teks bahasa Inggris
 * yang muncul (dan kalau itu pun tidak ada, bahasa Ceko), supaya lubangnya
 * kelihatan.
 *
 * Terjemahan ini belum dibaca oleh orang transgender yang berbahasa Indonesia.
 * Kosakata transisi dan cara menyapa di sini lebih penting daripada di tempat
 * lain: kalau ada yang terdengar salah, beri tahu kami dan kami ubah.
 */
const id = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Kembali',
  'obecne.hledat': 'Cari',
  'obecne.nacitani': 'Memuat…',
  'obecne.zrusit': 'Batal',
  'obecne.ulozit': 'Simpan',
  'obecne.odeslat': 'Kirim',
  'obecne.vice': 'Lihat semua',
  'obecne.jazyk': 'Bahasa',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Ruang aman untuk komunitas transgender, tempat kamu bisa bicara terbuka, mencari bantuan, dan merasakan dukungan orang lain.',
  'auth.prihlaseni': 'Masuk',
  'auth.registrace': 'Daftar',
  'auth.email': 'Email',
  'auth.heslo': 'Kata sandi',
  'auth.emailPriklad': 'kamu@contoh.com',
  'auth.prihlasitSe': 'Masuk',
  'auth.prihlasuji': 'Sedang masuk…',
  'auth.zapomenuteHeslo': 'Lupa kata sandi?',
  'auth.presGoogle': 'Masuk dengan Google',
  'auth.spatneUdaje': 'Email atau kata sandi salah',
  'auth.uspech': 'Kamu sudah masuk.',
  'auth.googleChyba': 'Masuk dengan Google gagal',
  'auth.obnoveniHesla': 'Atur ulang kata sandi',
  'auth.obnoveniOdeslano': 'Kalau email itu terdaftar, kamu akan menerima tautan untuk mengatur ulang kata sandi.',
  'auth.zpetNaPrihlaseni': 'Kembali ke halaman masuk',
  'auth.odeslatOdkaz': 'Kirim tautan',
  'auth.obnoveniChyba': 'Email tidak bisa dikirim. Coba lagi.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Satu langkah lagi: kodemu',
  'auth.jesteKodPopis': 'Buka aplikasi autentikator dan salin enam angka yang ditampilkan untuk Bloom.',
  'auth.kod': 'Kode',
  'auth.zalozniKodNapoveda': 'Tidak pegang ponsel? Masukkan salah satu kode cadangan yang kamu simpan saat mengaktifkannya.',
  'auth.potvrdit': 'Konfirmasi',
  'auth.overuji': 'Memeriksa…',
  'auth.kodNesedi': 'Kode itu tidak cocok',
  'auth.zalozniDochazeji': (p) => `Kode cadanganmu tinggal ${p.pocet}. Buat yang baru di profil.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Cara memasang Bloom di ponselmu',
  'auth.krokyAndroid': [
      'Buka halaman ini di Chrome',
      'Ketuk ikon tiga titik (⋮) di pojok kanan atas',
      'Pilih «Tambahkan ke layar utama» atau «Instal aplikasi»',
      'Konfirmasi pemasangan',
    ],
  'auth.krokyIos': [
      'Buka halaman ini di Safari',
      'Ketuk ikon bagikan (□↑) di bilah bawah',
      'Gulir ke bawah dan pilih «Ke Layar Utama»',
      'Konfirmasi dengan «Tambah»',
    ],
  'auth.seznamChranene': [
      { silne: 'Tidak ada data anggota yang bersifat publik.', text: 'Profil, cerita, tawaran, pertanyaan, foto, dan avatar hanya ditampilkan kepada yang sudah masuk. Tidak ada yang bisa diunduh atau dikumpulkan tanpa akun.' },
      { silne: 'Tidak ada yang tahu kata sandimu', text: '— kami pun tidak. Yang disimpan hanya sidik bcrypt, yang tidak bisa dikembalikan ke kata sandi asli.' },
      { silne: 'Pesan pribadi dan lampiran dienkripsi', text: '(AES + pemeriksaan integritas) sudah di disk server. Siapa pun yang mendapat cadangan atau disk hanya akan membaca karakter tanpa makna.' },
      { silne: 'Pesan menghapus dirinya sendiri', text: 'setelah jangka waktu tertentu (bawaan 90 hari), termasuk pesan suara dan foto. Yang sudah tidak ada di sini tidak bisa bocor.' },
      { silne: 'Tahap transisimu bersifat pribadi', text: 'sampai kamu sendiri mempublikasikannya. Langkah yang kamu centang di Panduan hanya kamu yang melihat.' },
      { silne: 'Email dan nomor telepon', text: 'tidak pernah ditampilkan kepada anggota lain.' },
      { silne: '', text: 'Proses masuk dilindungi dari penebakan kata sandi: jumlah percobaan dibatasi.' },
      { silne: 'Enkripsi pesan ujung ke ujung.', text: 'Kalau kamu mengaktifkannya, teks dan lampiran dienkripsi di peramban milikmu sendiri, dan server hanya menerima karakter yang tidak terbaca. Kuncinya dibuka dengan kata sandimu dan tidak pernah meninggalkan perangkatmu — jadi kami pun tidak bisa membaca isinya, bahkan kalau pengadilan memintanya. Harganya: kalau kamu lupa kata sandi, kamu juga tidak bisa membaca pesan lama.' },
      { silne: '', text: 'Status masuk tidak bertahan selamanya: Bloom mengeluarkanmu saat jendela ditutup dan setelah sepuluh menit tanpa aktivitas.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Metadata', text: '— siapa menulis kepada siapa dan kapan — harus diketahui server supaya pesan bisa sampai. Enkripsi ujung ke ujung tidak menyembunyikannya, Signal pun tidak.' },
      { silne: '', text: 'Bloom adalah aplikasi web, jadi setiap kali dibuka ia mengunduh kode enkripsinya dari server kami. Siapa pun yang menguasai server secara teori bisa menyajikan kode yang diubah. Hanya aplikasi bertanda tangan dari toko yang melindungi dari hal itu — karena itu Signal punya aplikasi, versi web tidak.' },
      { silne: 'Profil', text: '— nama panggilan, deskripsi, avatar — tidak bisa dienkripsi, karena server harus menampilkannya ke orang lain.' },
      { silne: '', text: 'Pesan dari sebelum enkripsi diaktifkan tetap terenkripsi hanya di disk server, bukan ujung ke ujung.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom bekerja seperti aplikasi, bahkan tanpa internet. Datamu selalu terbaru.',
  'auth.zabezpeceniTitulek': 'Bagaimana Bloom diamankan',
  'auth.zabezpeceniUvod': 'Bloom adalah ruang untuk komunitas transgender, jadi hal-hal sensitif bertemu di sini. Di bawah ini yang '
      + 'kami lakukan untuk melindunginya — dan yang tidak bisa kami lakukan — tanpa dibagus-baguskan.',
  'auth.coJeChranene': 'Apa yang dilindungi',
  'auth.coNeumime': 'Yang tidak bisa dilakukan Bloom — dan adil untuk mengatakannya',
  'auth.zabezpeceniZaver': 'Kalau kamu punya pertanyaan soal privasi atau menemukan celah, gunakan «Laporkan masalah» di bawah. Kami menanggapinya serius.',
  'auth.mvp': 'Bloom masih versi pertama dan kami terus memperbaikinya bersama komunitas. '
      + 'Kalau kamu menemui kesalahan atau punya ide, kami senang mendengarnya.',
  'auth.nahlasitProblem': 'Laporkan masalah',
  'auth.clenu': () => 'anggota',
  'auth.prispevku': () => 'unggahan',
  'auth.odborniku': () => 'tenaga profesional',
  'auth.nabidek': () => 'tawaran',

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Nama panggilan (unik)',
  'reg.prezdivkaPriklad': 'Minimal 3 karakter',
  'reg.telefon': 'Telepon',
  'reg.volitelne': '(opsional)',
  'reg.heslo': 'Kata sandi',
  'reg.hesloZnovu': 'Ulangi kata sandi',
  'reg.zajmeno': 'Kata ganti',
  'reg.oMne': 'Tentang saya',
  'reg.oMnePriklad': 'Beberapa kata tentang kamu…',
  'reg.registrovat': 'Buat akun',
  'reg.registruji': 'Membuat akun…',
  'reg.presGoogle': 'Daftar dengan Google',
  'reg.avatar': 'Avatar',
  'reg.neboFoto': 'Atau unggah fotomu sendiri',
  'reg.nahratFoto': 'Unggah foto',
  'reg.vlastni': 'Milik sendiri',
  'reg.zeme': 'Negara',
  'reg.kraj': 'Wilayah',
  'reg.nechciUvadet': 'Tidak ingin menyebutkan',
  'reg.cesko': 'Ceko',
  'reg.svet': 'Bagian dunia lainnya',

  // skupiny avatarů
  'reg.avatarFem': 'Feminin',
  'reg.avatarMask': 'Maskulin',
  'reg.avatarNeutr': 'Netral',
  'reg.avatarZvirata': 'Hewan',

  // komunitní heslo
  'reg.komunitniHeslo': 'Kata sandi komunitas',
  'reg.komunitniHesloPriklad': 'Masukkan kata sandi komunitas…',
  'reg.komunitniHesloPopis': 'Bloom adalah ruang pribadi untuk komunitas transgender. Seseorang dari komunitas bisa memberimu kata sandinya.',
  'reg.napisAdminovi': 'Kalau kamu tidak kenal siapa pun, tulis ke pengelola di',
  'reg.nevimHeslo': 'Saya tidak tahu kata sandi komunitas',
  'reg.jakZiskat': 'Kata sandi komunitas melindungi ruang pribadi ini. Cara mendapatkannya:',
  'reg.krok1': '1. Kirim email ke',
  'reg.krok2': '2. Perkenalkan dirimu singkat dan ceritakan dari mana kamu tahu Bloom',
  'reg.krok3': '3. Pengelola akan membalas secepat mungkin',

  // kontrola hesla
  'reg.hesloKratke': 'Kata sandi harus minimal 8 karakter',
  'reg.hesloMale': 'Kata sandi harus memuat huruf kecil',
  'reg.hesloVelke': 'Kata sandi harus memuat huruf besar',
  'reg.hesloCislo': 'Kata sandi harus memuat angka',
  'reg.hesloZnak': 'Kata sandi harus memuat karakter khusus (!@#$%…)',
  'reg.pozadavek8': 'Minimal 8 karakter',
  'reg.pozadavekVelke': 'Huruf besar',
  'reg.pozadavekCislo': 'Angka',
  'reg.pozadavekZnak': 'Karakter khusus (!@#$%)',
  'reg.hesloNesouhlasi': 'Kata sandinya tidak sama',
  'reg.prezdivkaKratka': 'Nama panggilan harus minimal 3 karakter',
  'reg.hesloPovinne': 'Kata sandi komunitas wajib diisi',
  'reg.hotovo': 'Akun dibuat. Cek emailmu untuk mengonfirmasinya.',
  'reg.fotoVelka': 'Gambar terlalu besar (maks. 2 MB)',
  'reg.chyba': 'Akun tidak bisa dibuat',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Di sini tidak ada yang harus sempurna. Bloom adalah ruang tempat setiap orang bisa menjadi dirinya — '
      + 'tempat kamu bisa berbagi pengalaman, bertanya, dan menolong orang lain. Tanpa penghakiman dan tanpa prasangka.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · diterjemahkan dari bahasa Ceko',
  'domu.vitej': 'Halo,',
  'domu.vCislech': 'Bloom dalam angka',
  'domu.noveVKomunite': 'Baru pertama kali di sini?',
  'domu.noveVKomunitePopis1': 'Kamu tidak harus terlihat. Kamu tidak butuh foto. Kamu tidak harus terbuka.',
  'domu.noveVKomunitePopis2': 'Bloom adalah ruang tempat kamu bisa mulai dengan iramamu sendiri.',
  'domu.rozcestnik1': 'Ini kali pertama saya di sini',
  'domu.rozcestnik2': 'Saya tidak tahu harus mulai dari mana',
  'domu.rozcestnik3': 'Saya ingin tetap anonim',
  'domu.rozcestnik4': 'Saya mencari tenaga profesional',
  'domu.rozcestnik5': 'Saya hanya ingin membaca pengalaman orang lain',
  'domu.otazky': 'Ada pertanyaan atau ingin tahu lebih banyak? Tulis ke kami di',
  'domu.doporucujeme': 'Rekomendasi',
  'domu.odbornici': 'Tenaga profesional',
  'domu.noviClenove': 'Orang baru di komunitas',
  'domu.zadniNovi': 'Belum ada yang baru',
  'domu.nejnovejsiOtazky': 'Pertanyaan terbaru',
  'domu.zadneOtazky': 'Belum ada pertanyaan.',
  'domu.nejlepeHodnoceni': 'Tenaga profesional dengan nilai tertinggi',
  'domu.zadniHodnoceni': 'Belum ada penilaian',
  'domu.zadneAktuality': 'Belum ada berita',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Tawarkan apa yang kamu bisa dan terima bantuan dari orang lain.',
  'domu.dlazdice.specialists': 'Temukan tenaga profesional terverifikasi, dari psikologi sampai bedah plastik.',
  'domu.dlazdice.legal': 'Bantuan hukum, artikel, dan jawaban atas pertanyaanmu.',
  'domu.dlazdice.nearby': 'Layanan dan tenaga profesional di dekatmu.',

  // počty
  'domu.pocetClenu': () => 'orang di komunitas',
  'domu.pocetZkusenosti': () => 'pengalaman yang dibagikan',
  'domu.pocetOdborniku': () => 'tenaga profesional terverifikasi',
  'domu.pocetNabidek': () => 'tawaran dukungan',

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Beranda',
  'nav.news': 'Berita',
  'nav.stories': 'Pengalaman komunitas',
  'nav.mapaSveta': 'Peta dunia',
  'nav.support': 'Saling bantu',
  'nav.specialists': 'Tenaga profesional ramah transgender',
  'nav.legal': 'Bantuan hukum',
  'nav.pageants': 'Kontes',
  'nav.nearby': 'Dekat saya',
  'nav.hledat': 'Cari di Bloom',
  'nav.hledatPlaceholder': 'Cari orang, tenaga profesional, artikel…',
  'nav.zpravy': 'Pesan',
  'nav.profil': 'Profil saya',
  'nav.mojeCesta': 'Perjalanan saya',
  'nav.administrace': 'Administrasi',
  'nav.odhlasit': 'Keluar',
  'nav.vsechnyVysledky': (p) => `Lihat semua hasil untuk «${p.dotaz}»`,
  'nav.overEmail': 'Konfirmasi emailmu',
  'nav.menu': 'Menu',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom di seluruh dunia',
  'svet.podtitulek': 'Pilih negara dan lihat apa yang dikumpulkan komunitas di sana.',
  'svet.hledatZemi': 'Cari negara…',
  'svet.vsechnyZeme': 'Semua negara',
  'svet.jenSObsahem': 'Hanya negara yang ada isinya',
  'svet.nicNenalezeno': 'Tidak ada negara yang cocok.',
  'svet.zaznamu': (p) => `${p.pocet} entri`,
  'svet.prazdnaZeme': 'Belum ada apa-apa',
  'svet.kontinent': 'Benua',
  'svet.celySvet': 'Seluruh dunia',
  'svet.vse': 'Semua',
  'svet.zacniDomovem': 'Mulailah dengan memilih negara tempatmu tinggal. Bisa juga dipilih dari daftar di bawah peta.',
  'svet.zkoumej': 'Pilih negara dan lihat apa yang Bloom punya di sana. Kamu boleh menjelajah ke mana saja — '
      + 'itu tidak mengubah negaramu.',
  'svet.domov': 'Rumah',
  'svet.zrusitDomov': 'Hapus negara tempat tinggal',
  'svet.nastavitDomov': 'Jadikan negara saya',
  'svet.zeSveta': 'Dari seluruh dunia',
  'svet.coSeChysta': 'Yang akan datang',
  'svet.souteze': 'Kontes yang pendaftarannya masih dibuka',
  'svet.noveOrganizace': 'Organisasi baru',
  'svet.kdeJizNeco': 'Di mana Bloom sudah punya sesuatu',
  'svet.hledatZemiPopisek': 'Cari negara',
  'svet.nicNeodpovida': 'Tidak ada yang cocok. Coba pencarian lain.',
  'svet.napovedaKMape': 'Seret peta untuk menggesernya, dan perbesar dengan roda tetikus atau tombol. Kamu tidak '
      + 'harus memakainya — kotak pencarian dan daftar lengkap negara ada di bawah.',
  'svet.tvujBloom': (p) => `Bloom-mu di ${p.zeme}`,
  'svet.tvojeDomovska': 'negara tempatmu tinggal',
  'svet.zemi': (p) => `${p.pocet} negara`,
  'svet.chyba': 'Daftar negara tidak bisa dimuat. Muat ulang halaman ini.',
  'svet.pocet.specialists': (p) => `${p.pocet} tenaga profesional`,
  'svet.pocet.organizations': (p) => `${p.pocet} organisasi`,
  'svet.pocet.events': (p) => `${p.pocet} acara`,
  'svet.pocet.pageants': (p) => `${p.pocet} kontes`,
  'svet.pocet.resources': (p) => `${p.pocet} sumber`,

  // světadíly
  'kontinent.europe': 'Eropa',
  'kontinent.asia': 'Asia',
  'kontinent.africa': 'Afrika',
  'kontinent.north_america': 'Amerika Utara',
  'kontinent.south_america': 'Amerika Selatan',
  'kontinent.oceania': 'Oseania',
  'kontinent.antarctica': 'Antarktika',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Kontes transgender dari seluruh dunia. Yang pendaftarannya masih terbuka ada di atas.',
  'souteze.hledat': 'Cari kontes…',
  'souteze.zadne': 'Kami belum punya kontes. Kamu tahu salah satunya? Kirim usulan.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Buka: ${p.zeme}`,
  'nahled.zavrit': 'Tutup pratinjau',
  'nahled.jenInformace': 'Untuk sekarang kami baru punya informasi tentang negara ini.',
  'nahled.zatimNic': 'Di sini kami belum punya kontak, organisasi, atau acara. Kamu tahu sesuatu? Kirim usulan.',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom di ${p.zeme}`,
  'zeme.podtitulek': (p) => `Apa yang dikumpulkan komunitas di ${p.zeme}.`,
  'zeme.prazdna': 'Bloom baru mulai di sini. Kamu bisa jadi orang pertama yang menambahkan sesuatu.',
  'zeme.mapaSveta': 'Peta dunia',
  'zeme.navrhnout': 'Usulkan entri',
  'zeme.domovska': 'Negara tempatmu tinggal',
  'zeme.nastavitDomovskou': 'Jadikan negara saya',
  'zeme.kdeToJe': 'Di mana menemukannya',
  'zeme.coTuBude': 'Apa yang akan kamu temukan di sini',
  'zeme.zatimPrazdne': 'masih kosong',
  'zeme.pripravujeme': 'sedang disiapkan',
  'zeme.zobrazitVse': (p) => `Lihat semua (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom baru tumbuh di sini',
  'zeme.rostePopis': 'Di sini kami belum punya apa-apa. Kamu tahu organisasi, acara, atau kontak '
      + 'yang berguna? Kirim usulan — akan melewati peninjauan lalu muncul di sini.',
  'zeme.jinouZemi': 'Lihat negara lain',
  'zeme.bezKontaktu': 'Di sini kami belum punya kontak atau organisasi.',
  'zeme.bezKontaktuPopis': 'Kamu kenal seseorang atau tahu sesuatu yang berguna di sini? Kirim usulan — akan '
      + 'melewati peninjauan lalu muncul di sini.',
  'zeme.neznama': 'Kami tidak mengenal negara itu.',
  'zeme.chyba': 'Negara tidak bisa dimuat.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Praktik dan klinik',
  'sekce.specialists.popis': 'Dokter, klinik, dan tenaga profesional lain yang punya rekam jejak di komunitas.',
  'sekce.organizations': 'Organisasi',
  'sekce.organizations.popis': 'Perkumpulan, lembaga nirlaba, dan kelompok dukungan.',
  'sekce.events': 'Acara',
  'sekce.events.popis': 'Pertemuan, Pride, lokakarya, dan konferensi.',
  'sekce.pageants': 'Kontes',
  'sekce.pageants.popis': 'Kontes transgender dan jadwalnya.',
  'sekce.resources': 'Sumber',
  'sekce.resources.popis': 'Informasi praktis tentang negara ini.',
  'sekce.community': 'Komunitas',
  'sekce.community.popis': 'Orang dan kelompok di negara ini.',
  'sekce.legal': 'Bantuan hukum',
  'sekce.legal.popis': 'Informasi dan dukungan untuk komunitas transgender',
  'sekce.support': 'Saling bantu',
  'sekce.support.popis': 'Tawarkan apa yang kamu bisa dan terima bantuan dari anggota lain di komunitas',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Cari di negara ini…',
  'vypis.vsechnyKategorie': 'Semua kategori',
  'vypis.kategorie': 'Kategori',
  'vypis.celaZeme': 'Seluruh negara',
  'vypis.navrhnout': 'Usulkan',
  'vypis.nicNeodpovida': 'Tidak ada yang cocok. Coba pencarian lain atau lepas filternya.',
  'vypis.zadneZaznamy': (p) => `Kami belum punya entri di ${p.zeme}.`,
  'vypis.zaznamu': (p) => `${p.pocet} entri`,
  'vypis.predchozi': 'Sebelumnya',
  'vypis.dalsi': 'Berikutnya',
  'vypis.chyba': 'Entri tidak bisa dimuat.',
  'vypis.neznamyDruh': 'Kami tidak mengenal jenis entri itu.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Kembali ke ${p.zeme}`,
  'detail.kontakty': 'Kontak dan tautan',
  'detail.podrobnosti': 'Detail',
  'detail.zacatek': 'Mulai',
  'detail.termin': 'Tanggal',
  'detail.uzaverka': 'Batas pendaftaran',
  'detail.prihlaska': 'Pendaftaran',
  'detail.strankaAkce': 'Halaman acara',
  'detail.web': 'Situs web',
  'detail.konec': 'Berakhir',
  'detail.stavRocniku': 'Status edisi',
  'detail.oblasti': 'Bidang kerja',
  'detail.coNabizi': 'Apa yang ditawarkan',
  'detail.kategorie': 'Kategori',
  'detail.jazyky': 'Bahasa',
  'detail.vitezove': 'Pemenang sebelumnya',
  'detail.kdoSeMuze': 'Siapa yang boleh ikut',
  'detail.poradatel': 'Penyelenggara',
  'detail.poplatek': 'Biaya',
  'detail.tema': 'Tema',
  'detail.forma.offline': 'Tatap muka',
  'detail.forma.online': 'Daring',
  'detail.forma.hybrid': 'Tatap muka dan daring',
  'detail.rozsah.local': 'Lokal',
  'detail.rozsah.national': 'Nasional',
  'detail.rozsah.international': 'Internasional',
  'detail.rocnik.upcoming': 'Akan datang',
  'detail.rocnik.registration_open': 'Pendaftaran dibuka',
  'detail.rocnik.registration_closed': 'Pendaftaran ditutup',
  'detail.rocnik.completed': 'Sudah berlangsung',
  'detail.zdroj': (p) => `Sumber: ${p.zdroj}`,
  'detail.upraveno': (p) => `Terakhir diperbarui: ${p.datum}`,
  'detail.overeno': 'Sudah diperiksa bahwa entri ini sesuai kenyataan. Ini bukan rekomendasi dari Bloom.',
  'detail.neovereno': 'Entri ini belum diperiksa. Datanya mungkin sudah berubah — cocokkan dengan sumbernya.',
  'detail.nenalezen': 'Kami tidak mengenal entri itu. Mungkin sudah dihapus atau masih menunggu peninjauan.',
  'detail.chyba': 'Entri tidak bisa dimuat.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'Apa yang berlaku di sini',
  'profil.name_change': 'Perubahan nama',
  'profil.gender_marker': 'Perubahan penanda gender',
  'profil.surgery_required': 'Apakah operasi diwajibkan',
  'profil.healthcare': 'Akses ke layanan kesehatan',
  'profil.legal_protection': 'Perlindungan dari diskriminasi',
  'profil.safety': 'Keamanan',
  'profil.stav.yes': 'Ya',
  'profil.stav.limited': 'Sebagian',
  'profil.stav.no': 'Tidak',
  'profil.stav.unknown': 'Tidak ada data',
  'profil.zdroj': 'Sumber',
  'profil.zdrojZRoku': (p) => `sumber dari tahun ${p.rok}`,
  'profil.overeno': (p) => `Diperiksa ${p.datum}`,
  'profil.zmena': 'Perubahan terbaru',
  'profil.odKdy': (p) => `berlaku sejak ${p.datum}`,
  'profil.doklady': 'Sumber',
  'profil.zakon': 'undang-undang atau putusan',
  'profil.upozorneni': 'Ini bukan nasihat hukum. Undang-undang berubah dan banyak hal bergantung pada '
      + 'situasimu sendiri — cocokkan dengan sumbernya atau dengan organisasi di '
      + 'negara itu sebelum mengambil langkah.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Usulkan ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Usulanmu melewati peninjauan sebelum muncul di Bloom. Isi yang '
      + 'kamu tahu — sisanya kami lengkapi.',
  'navrh.jednotne.organizations': 'sebuah organisasi',
  'navrh.jednotne.events': 'sebuah acara',
  'navrh.jednotne.pageants': 'sebuah kontes',
  'navrh.jednotne.resources': 'sebuah sumber',
  'navrh.popis.organizations': 'Perkumpulan, lembaga nirlaba, atau kelompok dukungan.',
  'navrh.popis.events': 'Pertemuan, Pride, lokakarya, konferensi.',
  'navrh.popis.pageants': 'Kontes transgender – tanggal, pendaftaran, penyelenggara.',
  'navrh.popis.resources': 'Informasi praktis – kesehatan, hukum, dokumen, kontak.',
  'navrh.nazev': 'Nama',
  'navrh.popisPole': 'Deskripsi',
  'navrh.zeme': 'Negara',
  'navrh.mesto': 'Kota',
  'navrh.adresa': 'Alamat',
  'navrh.web': 'Situs web',
  'navrh.email': 'Email',
  'navrh.telefon': 'Telepon',
  'navrh.odkudVis': 'Dari mana kamu tahu',
  'navrh.odkudVisPriklad': 'mis. dari situs mereka, saya pernah ke sana…',
  'navrh.vyberte': '— pilih —',
  'navrh.forma': 'Format',
  'navrh.rozsah': 'Cakupan',
  'navrh.platiPro': 'Berlaku untuk',
  'navrh.platnost.global': 'Seluruh dunia',
  'navrh.platnost.country': 'Sebuah negara',
  'navrh.platnost.region': 'Sebuah wilayah',
  'navrh.platnost.city': 'Sebuah kota',
  'navrh.odkazAkce': 'Tautan acara',
  'navrh.odkazPrihlaska': 'Tautan pendaftaran',
  'navrh.odkazy': 'Tautan',
  'navrh.text': 'Teks',
  'navrh.odeslat': 'Kirim usulan',
  'navrh.odesilam': 'Mengirim…',
  'navrh.chyba': 'Usulan tidak bisa dikirim',
  'navrh.dikyTitulek': 'Terima kasih, sudah kami terima',
  'navrh.dikyPopis': 'Kami sudah menerima usulanmu. Seseorang akan meninjaunya lalu ia muncul '
      + 'di Bloom. Tidak ada yang diterbitkan otomatis.',
  'navrh.zavrit': 'Tutup',
  'navrh.seznamNapoveda': 'Pisahkan tiap butir dengan koma.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `Apakah ${p.druh} ini milikmu?`,
  'prevzeti.popis': 'Kamu bisa mengambil alih profil ini dan menjaga datanya tetap baru. '
      + 'Permintaan melewati peninjauan lebih dulu.',
  'prevzeti.tlacitko': 'Ambil alih profil ini',
  'prevzeti.spravujes': 'Kamu mengelola profil ini. Datanya bisa kamu perbaiki kapan saja — perubahan langsung berlaku.',
  'prevzeti.upravit': 'Ubah data',
  'prevzeti.spravujeSama': (p) => `Profil ini dikelola sendiri oleh ${p.druh}.`,
  'prevzeti.ceka': 'Kami sudah menerima permintaanmu dan sedang meninjaunya.',
  'prevzeti.formulacTitulek': (p) => `Ambil alih profil — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Sebelum menyerahkan profil, kami perlu tahu kamu memang bagian dari '
      + 'organisasi itu. Permintaan melewati peninjauan; untuk sekarang belum ada yang berubah.',
  'prevzeti.role': 'Apa peranmu di sana?',
  'prevzeti.rolePriklad': 'mis. koordinator, ketua perkumpulan',
  'prevzeti.doklad': 'Bagaimana kami bisa memeriksanya?',
  'prevzeti.dokladPriklad': 'mis. nama saya ada di halaman kontak organisasi; atau tulis dari alamat resmi',
  'prevzeti.dokladNapoveda': 'Cukup tautan ke halaman yang mencantumkan namamu, atau alamat resmi '
      + 'organisasi untuk mengirim pesan.',
  'prevzeti.kontakt': 'Kontakmu',
  'prevzeti.kontaktPriklad': 'email atau telepon',
  'prevzeti.dalsi': 'Ada lagi',
  'prevzeti.nepovinne': '(opsional)',
  'prevzeti.odeslat': 'Kirim permintaan',
  'prevzeti.odesilam': 'Mengirim…',
  'prevzeti.vyplnObe': 'Beri tahu kami apa peranmu dan bagaimana itu bisa diperiksa.',
  'prevzeti.prijato': 'Terima kasih. Permintaanmu sudah kami terima dan akan kami balas.',
  'prevzeti.chyba': 'Permintaan tidak bisa dikirim.',
  'prevzeti.upravaTitulek': (p) => `Ubah profil — ${p.nazev}`,
  'prevzeti.upravaPopis': 'Nama dan lokasi sengaja tidak ada di sini: entri dicari dan '
      + 'diurutkan berdasarkan keduanya. Kalau berubah, tulis ke kami dan kami perbarui.',
  'prevzeti.popisPole': 'Deskripsi',
  'prevzeti.email': 'Email',
  'prevzeti.telefon': 'Telepon',
  'prevzeti.web': 'Situs web',
  'prevzeti.ulozeno': 'Tersimpan.',
  'prevzeti.ukladam': 'Menyimpan…',
  'prevzeti.chybaUlozeni': 'Tidak bisa disimpan.',
  'prevzeti.druh.organizations': 'organisasi',
  'prevzeti.druh.events': 'acara',
  'prevzeti.druh.pageants': 'kontes',

  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Ubah data dan pengaturanmu',
  'profil.overeny': 'Terkonfirmasi',
  'profil.neovereny': 'Belum terkonfirmasi',
  'profil.overteEmail': 'Konfirmasi emailmu. Akun yang belum terkonfirmasi punya hak terbatas.',
  'profil.emailOdeslan': 'Email konfirmasi terkirim.',
  'profil.emailChyba': 'Email tidak bisa dikirim',
  'profil.odeslano': 'Terkirim.',
  'profil.overeniOdbornika': 'Verifikasi sebagai tenaga profesional atau ahli hukum',
  'profil.pracujeteVOboru': 'Kamu bekerja di bidang ini? Dapatkan lencana verifikasi.',
  'profil.zadostOdeslana': 'Permintaan terkirim',
  'profil.pozadatOOvereni': 'Minta verifikasi',
  'profil.zadostTitulek': 'Minta verifikasi sebagai tenaga profesional atau ahli hukum',
  'profil.zadostPopis': 'Isi data permintaanmu. Tim moderasi akan meninjaunya.',
  'profil.pozadovanaRole': 'Peran yang diminta',
  'profil.roleOdbornik': 'Tenaga profesional',
  'profil.rolePravnik': 'Ahli hukum',
  'profil.specializace': 'Spesialisasi',
  'profil.odkazNaProfil': 'Tautan ke profil profesional',
  'profil.zpravaProAdmina': 'Pesan singkat untuk pengelola',
  'profil.odesilam': 'Mengirim…',
  'profil.odeslatZadost': 'Kirim permintaan verifikasi',
  'profil.vyplnteSpecializaci': 'Isi spesialisasimu',
  'profil.zadostUspech': 'Permintaan verifikasimu sudah terkirim.',
  'profil.zadostChyba': 'Permintaan tidak bisa dikirim',

  // bezpečnost
  'bezp.titulek': 'Keamanan',
  'bezp.sifrovaniZapnuto': (p) => `Enkripsi pesan aktif${p.odemceno ? ' dan terbuka' : ' (terkunci di tab ini)'}.`,
  'bezp.sifrovaniVypnuto': 'Kamu belum mengaktifkan enkripsi pesan.',
  'bezp.sifrovaniKde': 'Kamu mengaktifkan dan membukanya di halaman Pesan.',
  'bezp.sifrovaniKdeVypnute': 'Kamu bisa mengaktifkannya di halaman Pesan, di percakapan mana pun.',
  'bezp.zmenaHesla': 'Ganti kata sandi',
  'bezp.zmenaHeslaSifrovani': 'Enkripsi kamu aktif, jadi mengganti kata sandi juga membungkus ulang kunci pesanmu. '
      + 'Karena itu kata sandi saat ini diperlukan — tanpanya kuncinya tidak bisa dibuka dan pesanmu hilang.',
  'bezp.stavajiciHeslo': 'Kata sandi saat ini',
  'bezp.noveHeslo': 'Kata sandi baru',
  'bezp.noveHesloZnovu': 'Ulangi kata sandi baru',
  'bezp.pozadavky': 'Minimal 8 karakter, huruf besar dan kecil, satu angka, dan satu karakter khusus.',
  'bezp.zmenitHeslo': 'Ganti kata sandi',
  'bezp.menim': 'Mengganti…',
  'bezp.hesloNeshoda': 'Kata sandi barunya tidak sama.',
  'bezp.vyplnObe': 'Isi kedua kata sandi.',
  'bezp.stareNesedi': 'Kata sandi saat ini salah — kunci pesanmu bisa hilang, jadi tidak ada yang diubah.',
  'bezp.zmenenoSKlicem': 'Kata sandi diganti. Kunci pesanmu dibungkus ulang, jadi pesan lama tetap terbaca.',
  'bezp.zmeneno': 'Kata sandi diganti.',
  'bezp.zmenaChyba': 'Kata sandi tidak bisa diganti.',
  'bezp.nepamatujes': 'Tidak ingat kata sandi kuncinya?',
  'bezp.zahoditPopis': 'Kamu bisa membuang kuncinya dan mulai lagi. Pesan yang sudah dienkripsi selama ini akan hilang selamanya — '
      + 'tidak ada yang bisa membacanya, kami pun tidak. Justru karena itu ia aman.',
  'bezp.zahodit': 'Buang kunci dan mulai lagi',
  'bezp.zahoditPotvrzeni': 'Benar-benar membuang kuncinya?\n\nSemua pesan yang sudah dienkripsi akan hilang selamanya — '
      + 'tidak ada yang bisa membacanya, kami pun tidak. Lakukan ini hanya kalau kamu tidak ingat kata sandi '
      + 'yang kamu pakai saat mengaktifkan enkripsi.',
  'bezp.klicSmazan': 'Kunci dihapus. Muat ulang halaman ini.',
  'bezp.nepovedlo': 'Tidak berhasil.',
  'bezp.prohlizecNeumi': 'Peramban ini tidak mendukung enkripsi yang dipakai Bloom.',

  'profil.mujProfil': 'Profil saya',
  'profil.specializacePriklad': 'mis. psikologi, seksologi, hukum…',
  'profil.zpravaPriklad': 'Misalnya tautan ke izin praktikmu atau situs kliniknya…',
  'profil.overeniUvod': 'Ingin menjadi tenaga profesional atau ahli hukum terverifikasi di Bloom? Kirim permintaan verifikasi. '
      + 'Profilmu harus sesuai dengan profesimu yang sebenarnya.',

  'profil.oborPriklad': 'mis. bedah plastik, hukum keluarga…',
  'profil.nepovinnyText': 'Catatan tambahan, opsional…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Masuk dua langkah',
  'dvf.zapnuto': (p) => `Aktif. Kode cadanganmu tersisa ${p.pocet}.`,
  'dvf.vypnuto': 'Selain kata sandi, kamu juga memasukkan kode enam angka dari aplikasi di ponselmu.',
  'dvf.chraniA': 'Ini melindungi',
  'dvf.chraniPrihlaseni': 'proses masuk',
  'dvf.chraniB': ': orang yang tahu kata sandimu tapi tidak punya ponselmu tetap tidak bisa masuk.',
  'dvf.nechrani': 'Ini tidak melindungi pesan yang terenkripsi',
  'dvf.nechraniPopis': ' — pesan itu dibuka dengan kata sandimu di peramban milikmu sendiri, tanpa server.',
  'dvf.ulozKody': 'Simpan sepuluh kode cadangan ini',
  'dvf.ulozKodyPopis1': 'Masing-masing hanya berlaku sekali, dan inilah satu-satunya jalan masuk kalau ponselmu hilang.',
  'dvf.znovuNeukaze': 'Tidak ada yang akan menunjukkannya lagi',
  'dvf.ulozKodyPopis2': ' — kami hanya menyimpan sidiknya.',
  'dvf.zkopirovat': 'Salin',
  'dvf.ulozilaJsem': 'Sudah saya simpan',
  'dvf.zkopirovano': 'Tersalin.',
  'dvf.kopieChyba': 'Gagal menyalin, tolong catat manual.',
  'dvf.zapnout': 'Aktifkan masuk dua langkah',
  'dvf.pripravuji': 'Menyiapkan…',
  'dvf.nactiKod': 'Pindai kode ini di aplikasi autentikator — misalnya Google Authenticator, Authy, 1Password, atau Aegis.',
  'dvf.qrNejde': 'Tidak bisa memindai kode QR?',
  'dvf.zadejRucne': 'Masukkan kunci ini di aplikasi secara manual:',
  'dvf.opisKod': 'Masukkan kode yang ditampilkan aplikasi',
  'dvf.zapnoutKratce': 'Aktifkan',
  'dvf.overuji': 'Memeriksa…',
  'dvf.noveKody': 'Kode cadangan baru',
  'dvf.vypnout': 'Matikan',
  'dvf.noveKodyPopis': 'Set baru menggantikan yang lama — kode cadanganmu yang sekarang berhenti berlaku.',
  'dvf.kodZAplikace': 'Kode dari aplikasi',
  'dvf.vygenerovat': 'Buat',
  'dvf.vypnutiPopis': 'Mematikannya butuh kata sandimu dan kode yang masih berlaku. Keduanya disengaja: kalau tidak, siapa pun yang bisa mengakses peramban yang terbuka bisa melepasnya.',
  'dvf.kodNeboZalozni': 'Kode dari aplikasi atau kode cadangan',
  'dvf.vypinam': 'Mematikan…',
  'dvf.vypnoutCele': 'Matikan masuk dua langkah',
  'dvf.vypnuto2': 'Masuk dua langkah dimatikan.',
  'dvf.kodNesedi': 'Kode itu tidak cocok.',
  'dvf.nepovedlo': 'Tidak berhasil.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Profil diperbarui.',
  'pf.chyba': 'Profil tidak bisa diperbarui',
  'pf.fotkaNahrana': 'Foto terunggah.',
  'pf.fotkaChyba': 'Gambar tidak bisa diunggah',
  'pf.fotkaVelka': 'Gambar terlalu besar (maks. 5 MB)',
  'pf.oznameniUlozeno': 'Pengaturan notifikasi tersimpan.',
  'pf.oznameniChyba': 'Pengaturan tidak bisa disimpan',
  'pf.zruseno': 'Profilmu sudah dihapus',
  'pf.zruseniChyba': 'Profil tidak bisa dihapus',
  'pf.zruseniPotvrzeni': 'Kamu benar-benar mau menghapus profilmu? Ini tidak bisa dibatalkan dan semua datamu akan terhapus.',
  'pf.urlFacebook': 'Alamat Facebook harus diawali https://',
  'pf.urlInstagram': 'Alamat Instagram harus diawali https://',
  'pf.urlLinkedin': 'Alamat LinkedIn harus diawali https://',
  'pf.ukladam': 'Menyimpan…',
  'pf.ulozitOznameni': 'Simpan pengaturan notifikasi',
  'pf.oznameniZpravy': 'Pesan pribadi',
  'pf.oznameniAdmin': 'Pesan baru dari pengelola',
  'pf.oznameniUzivatel': 'Pesan baru dari orang lain',
  'pf.oznameniPodpora': 'Unggahan baru di Saling bantu',
  'pf.oznameniNabidky': 'Tawaran dan permintaan',

  // odznaky
  'pf.odznakAdmin': 'Pengelola',
  'pf.odznakPravnik': 'Ahli hukum',
  'pf.odznakSpecialista': 'Tenaga profesional terverifikasi',
  'pf.odznakClen': 'Anggota komunitas terverifikasi',
  'pf.odznakPomocnik': 'Penolong aktif',
  'pf.odznakDuveryhodny': 'Orang tepercaya',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Foto ditambahkan ke galeri.',
  'gal.smazano': 'Foto dihapus',
  'gal.hesloKratke': 'Kata sandi galeri harus minimal 4 karakter',
  'gal.nahraniChyba': 'Foto tidak bisa diunggah',
  'gal.mazaniChyba': 'Foto tidak bisa dihapus',
  'gal.souborVelky': 'Berkas terlalu besar (maks. 5 MB)',
  'gal.ulozitNastaveni': 'Simpan pengaturan',
  'gal.hesloPopis': 'Pengunjung harus memasukkan kata sandi ini untuk melihat galeri.',
  'gal.pridat': 'Tambah foto atau video',
  'gal.prazdna': 'Belum ada foto di galeri',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Saya sedang di mana?',
  'cesta.popis': 'Bagikan tahap transisimu kalau kamu mau — atau simpan untuk dirimu sendiri.',
  'cesta.soukroma': 'Tahapmu bersifat pribadi',
  'cesta.viditelna': 'Tahapmu terlihat oleh orang lain',
  'cesta.jenTy': 'Hanya kamu yang melihat tahapmu',
  'cesta.mohouNajit': 'Orang lain bisa menemukanmu lewat «Cari orang di tahap serupa»',
  'cesta.poznamka': 'Catatan pribadi',
  'cesta.volitelna': '(opsional)',
  'cesta.poznamkaPriklad': 'Apa pun yang ingin kamu bagikan atau ingat…',
  'cesta.najitPodobne': 'Cari orang di tahap serupa',
  'cesta.hledam': 'Mencari…',
  'cesta.ulozit': 'Simpan perjalanan saya',
  'cesta.ulozeno': 'Perjalananmu tersimpan.',
  'cesta.vyberteFazi': 'Pilih satu tahap',
  'cesta.chyba': 'Tidak bisa disimpan',

  'pf.socialniSite': 'Media sosial',
  'pf.avatarFoto': 'Avatar / foto profil',
  'pf.nahratProfilni': 'Unggah foto profil',
  'pf.zrusitProfil': 'Hapus profil',
  'pf.nastaveniOznameni': 'Pengaturan notifikasi',
  'pf.nastaveniOznameniPopis': 'Pilih hal apa saja yang ingin kamu dapat kabarnya.',
  'gal.overEmail': 'Untuk mengunggah foto, konfirmasi emailmu dulu.',
  'cesta.coMeCeka': 'Apa yang menanti saya',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Pesan',
  'zpr.hledatUzivatele': 'Cari orang…',
  'zpr.zadneKonverzace': 'Belum ada percakapan',
  'zpr.vyhledejteVyse': 'Cari orang di atas',
  'zpr.vyberteKonverzaci': 'Pilih percakapan atau cari seseorang',
  'zpr.napisteZpravu': 'Tulis pesan…',
  'zpr.nahravam': 'Merekam…',
  'zpr.prilozitObrazek': 'Lampirkan gambar',
  'zpr.hlasovaZprava': 'Pesan suara',
  'zpr.zastavitNahravani': 'Hentikan rekaman',
  'zpr.obrazek': 'Gambar',
  'zpr.overteEmail': 'Untuk mengirim pesan, konfirmasi emailmu.',
  'zpr.profil': 'Profil',

  // šifrování
  'zpr.sifrovanaZprava': 'Pesan terenkripsi',
  'zpr.odemkniNahore': 'Pesan terenkripsi — buka kunci pesanmu di atas.',
  'zpr.nelzeOtevrit': 'Pesan terenkripsi ini tidak bisa dibuka.',

  // hlášky
  'zpr.uzivatelNenalezen': 'Orang itu tidak ditemukan',
  'zpr.prijemceNenalezen': 'Penerima tidak ditemukan',
  'zpr.prihlasteZnovu': 'Masuk lagi (sesimu berakhir)',
  'zpr.serverNedostupny': 'Server tidak terjangkau. Periksa apakah backend berjalan.',
  'zpr.chybaOdeslani': 'Gagal mengirim',
  'zpr.souborVelky': 'Berkas terlalu besar (maks. 5 MB)',
  'zpr.formatNepodporovan': 'Jenis berkas tidak didukung',
  'zpr.mediaOdeslano': 'Berkas terkirim',
  'zpr.mikrofon': 'Mikrofon tidak tersedia',
  'zpr.hlasovkaOdeslana': 'Pesan suara terkirim',
  'zpr.hlasovkaChyba': (p) => `Pesan suara gagal dikirim: ${p.detail}`,
  'zpr.smazano': 'Percakapan dihapus',
  'zpr.smazaniChyba': 'Percakapan tidak bisa dihapus',
  'zpr.smazaniPotvrzeni': 'Ia hilang dari daftarmu, berikut lampirannya. Orang satunya tetap punya salinannya — '
      + 'pesan baru benar-benar terhapus dari server kalau kalian berdua menghapusnya.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Masukkan kata sandimu.',
  'sif.zapnuto': 'Enkripsi aktif.',
  'sif.odemceno': 'Pesanmu sudah terbuka.',
  'sif.hesloNesedi': 'Kata sandi itu salah.',
  'sif.prohlizecNeumi': 'Peramban ini tidak mendukung enkripsi yang dipakai Bloom. Kamu tetap bisa menulis, '
      + 'tapi pesannya tidak akan terenkripsi ujung ke ujung.',
  'sif.noveJsouSifrovane': 'Pesan baru terenkripsi. Hanya kamu yang punya kuncinya — server tidak bisa membacanya.',
  'sif.odemkniZpravy': 'Buka kunci pesanmu',
  'sif.odemkniPopis': 'Kuncinya hanya hidup di memori tab ini, jadi setelah halaman dimuat ulang kata sandinya diminta lagi. '
      + 'Kami tidak bisa menyimpannya di mana pun — kalau bisa, itu bukan lagi enkripsi yang kamu kendalikan sendiri.',
  'sif.zapniSifrovani': 'Aktifkan enkripsi pesan',
  'sif.zapniPopis': 'Pesan baru dienkripsi di sini, di perangkatmu. Server hanya menerima karakter yang tak terbaca '
      + 'dan tidak bisa membacanya — bahkan kalau pengadilan memintanya.',
  'sif.pozorA': 'Hati-hati: kuncinya dibuka dengan kata sandimu.',
  'sif.pozorTucne': 'Kalau kamu lupa, tidak ada yang bisa membaca pesan terenkripsimu',
  'sif.pozorB': ' — kami pun tidak. Justru itu intinya, tapi artinya kamu butuh tempat untuk menyimpannya.',
  'sif.mobilA': 'Mengaktifkannya juga mengubah cara kamu masuk: kata sandimu sama sekali tidak lagi sampai ke server, hanya sidiknya yang dikirim.',
  'sif.mobilTucne': 'Aplikasi ponsel Bloom yang lama nanti tidak bisa masuk ke akun ini',
  'sif.mobilB': ' sampai kami memperbaruinya. Di web semuanya tetap berjalan.',
  'sif.zapnoutSifrovani': 'Aktifkan enkripsi',
  'sif.odemknout': 'Buka kunci',
  'sif.tvojeHeslo': 'Kata sandi Bloom-mu',
  'sif.prilohaZamcena': 'Lampiran terenkripsi — buka kunci pesanmu di atas.',
  'sif.prilohaChyba': 'Lampiran tidak bisa dibuka.',
  'sif.priloha': 'Lampiran pesan',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Lokasimu',
  'okoli.nastavtePolohu': 'Beri tahu kamu di mana supaya hasilnya sesuai',
  'okoli.vyberteVyse': 'Pilih lokasi di atas untuk melihat tawaran dan tenaga profesional di dekatmu',
  'okoli.zadniOdbornici': 'Belum ada tenaga profesional terdaftar di wilayah ini',
  'okoli.zadneNabidky': 'Belum ada tawaran di wilayah ini',
  'okoli.zadniClenove': 'Belum ada orang dari komunitas di wilayah ini',
  'okoli.vytvoritNabidku': 'Buat tawaran',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Mencari:',
  'hled.vysledkyPro': 'Hasil pencarian:',
  'hled.nicPro': 'Kami tidak menemukan apa pun untuk:',
  'hled.nicZkuste': 'Kami tidak menemukan apa pun. Coba kata lain.',
  'hled.zkratte': 'Coba frasa yang lebih pendek atau kata kunci lain.',
  'hled.zadejte': 'Tulis yang kamu cari lalu tekan Enter',
  'hled.priklady': 'Misalnya: FFS, hormon, nama, dokter, dokumen, operasi…',
  'hled.uzivatele': 'Orang',
  'hled.odbornici': 'Tenaga profesional ramah transgender',
  'hled.clanky': 'Bantuan hukum – artikel',
  'hled.otazky': 'Pertanyaan komunitas',
  'hled.nabidky': 'Tawaran bantuan',
  'hled.prispevky': 'Unggahan',
  'hled.recenze': 'Ulasan tenaga profesional',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'Orang itu tidak ditemukan',
  'up.oMne': 'Tentang',
  'up.clenOd': 'Di Bloom sejak',
  'up.odznakSpravce': 'Pengelola',
  'up.odznakPravnik': 'Ahli hukum',
  'up.odznakOdbornik': 'Tenaga profesional terverifikasi',
  'up.odznakPravnikOvereny': 'Ahli hukum terverifikasi',
  'up.odznakClen': 'Anggota terverifikasi',
  'up.odznakPomocnik': 'Penolong aktif',
  'up.odznakDuveryhodny': 'Tepercaya',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Kembali ke Bloom',
  'kom.oProjektu': 'Bloom lahir sebagai ruang komunitas yang aman untuk orang transgender di Ceko — tempat '
      + 'untuk berbagi pengalaman, menemukan dukungan, menjangkau tenaga profesional, dan berkenalan. '
      + 'Proyek ini dijalankan komunitas secara sukarela. Tujuannya: kerahasiaan, privasi, dan saling bantu.',
  'kom.kontaktText': 'Ada pertanyaan atau butuh bantuan? Hubungi kami. Kami berusaha membalas secepat mungkin.',
  'kom.respekt': 'Kita saling menghormati',
  'kom.respektPopis': 'Kita memanggil setiap orang dengan nama dan kata ganti yang mereka pakai. Kita menghormati jalan dan pengalaman yang berbeda — '
      + 'tidak ada cara yang benar atau salah untuk menjadi transgender.',
  'kom.soukromi': 'Kita menjaga privasi satu sama lain',
  'kom.soukromiPopis': 'Apa yang dibagikan di Bloom tetap di Bloom. Jangan bagikan informasi tentang orang lain tanpa '
      + 'persetujuan mereka. Kita menghormati anonimitas.',
  'kom.pomahame': 'Kita saling menolong',
  'kom.pomahamePopis': 'Bloom adalah soal dukungan bersama. Kita berbagi pengalaman, saling membantu, dan membangun ruang aman '
      + 'untuk siapa pun yang mencari sambungan atau informasi.',
  'kom.obtezovani': 'Kami tidak menoleransi pelecehan',
  'kom.obtezovaniPopis': 'Pelecehan, perundungan, atau komentar bermusuhan tidak punya tempat di Bloom. Kalau kamu merasa tidak nyaman, '
      + 'tulis ke pengelola.',
  'kom.spam': 'Tanpa spam dan iklan',
  'kom.spamPopis': 'Bloom bukan pasar. Jangan memasang iklan yang tidak diminta atau konten komersial. '
      + 'Tawaran dan permintaan tempatnya di Saling bantu.',
  'kom.prostor': 'Ruang untuk setiap tahap',
  'kom.prostorPopis': 'Kamu tidak sendirian, di titik mana pun kamu berada. Kami menyambut orang yang baru memikirkan '
      + 'transisi, yang sedang menjalaninya, dan yang sudah melewatinya — dan menerima setiap jalan apa adanya.',
  'kom.dataPopis': 'Bloom hanya mengumpulkan data yang dibutuhkan platform untuk berjalan: emailmu, nama panggilan, dan profil '
      + 'yang kamu buat sendiri.',
  'kom.dataTretiStrany': 'Datamu tidak dibagikan ke pihak ketiga. Platform ini tidak memakai teknologi pelacakan maupun jaringan iklan.',
  'kom.dataSmazani': 'Kamu berhak meminta akun dan seluruh data terkait dihapus. Hubungi pengelola.',

  'okoli.podtitulek': 'Temukan orang dari komunitas, layanan, dan tenaga profesional di dekatmu',
  'okoli.cleneVOkoli': (p) => `Orang dari komunitas di dekat ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Tawaran bantuan di dekat ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Tenaga profesional di dekat ${p.misto}`,
  'hled.zobrazitVice': 'Lihat lainnya',
  'kom.titulek': 'Aturan komunitas',
  'kom.podtitulek': 'Ruang aman untuk semua orang',
  'kom.jakNahlasit': 'Cara melaporkan masalah',
  'kom.jakNahlasitPopis': 'Kalau kamu menemui perilaku yang tidak pantas, ada dua cara: tombol «Laporkan orang ini» '
      + 'di profilnya, atau tulis ke pengelola.',
  'kom.duverne': 'Laporanmu bersifat rahasia.',
  'kom.ochranaSoukromi': 'Privasi',
  'obecne.zpetKratce': 'Kembali',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Belum ada orang lain di komunitas yang membagikan tahap ini secara publik.',
  'cesta.poznamkaFazePriklad': 'Apa pun yang ingin kamu bagikan atau ingat tentang tahap ini…',
  'pruvodce.fazeNenalezena': 'Tahap tidak ditemukan',
  'pruvodce.pripravujeme': 'Bagian ini masih kami siapkan.',
  'pruvodce.krokyJenTy': 'Langkah yang kamu centang hanya kamu yang melihat.',
  'pruvodce.nastavitFazi': 'Jadikan tahap saya sekarang',
  'pruvodce.fazeNastavena': 'Sudah dijadikan tahapmu sekarang',
  'pruvodce.chyba': 'Tidak bisa disimpan, coba lagi',
  'pruvodce.kroku': 'langkah',
  'pruvodce.odborniku': () => 'tenaga profesional untuk tahap ini',
  'pruvodce.pribehu': () => 'cerita dari orang di tahap ini',

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Atur ulang kata sandi',
  'reset.popis': 'Masukkan kata sandi baru untuk akun Bloom-mu.',
  'reset.noveHeslo': 'Kata sandi baru',
  'reset.noveHesloPriklad': 'Masukkan kata sandi baru',
  'reset.potvrdit': 'Konfirmasi kata sandi baru',
  'reset.nastavit': 'Simpan kata sandi baru',
  'reset.ukladam': 'Menyimpan…',
  'reset.hotovo': 'Kata sandimu sudah diganti. Sekarang kamu bisa masuk.',
  'reset.neplatnyOdkaz': 'Tautan pengaturan ulang itu tidak berlaku.',
  'reset.odkazVyprsel': 'Tautannya kedaluwarsa atau tidak berlaku. Minta yang baru.',
  'reset.chyba': 'Kata sandi tidak bisa diatur ulang.',
  'reset.neshoda': 'Kata sandinya tidak sama.',
  'reset.ztratiPristup': 'akan kehilangan akses',

  'cesta.volitelne': 'Ini sepenuhnya pilihan. Bagikan tahap transisimu kalau kamu mau — atau simpan untuk dirimu sendiri. '
      + 'Kamu juga bisa menemukan orang di titik perjalanan yang mirip.',
  'cesta.hledatVeFazi': 'Cari orang di tahap ini:',
  'cesta.jenVerejne': '(hanya yang membagikannya secara publik)',
  'pruvodce.zpetNaCestu': 'Kembali ke Perjalanan saya',
  'pruvodce.tadyJsi': 'Kamu ada di sini',
  'reset.prejitNaPrihlaseni': 'Ke halaman masuk',
  'reset.sifrovaniVarovani': 'Kalau enkripsi pesanmu aktif: mengatur ulang kata sandi berarti kamu tidak lagi bisa menjangkau '
      + 'pesan terenkripsimu yang lama. Kuncinya dibuka dengan kata sandi asli, yang tidak diketahui siapa pun di sini, jadi tidak bisa '
      + 'dibungkus ulang. Pesan baru tetap bisa dienkripsi; pesan lama tidak akan terbaca — oleh kami pun tidak.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Masuk',
  'uvod.vytvoritUcet': 'Buat akun',
  'uvod.uzMamUcet': 'Saya sudah punya akun',
  'uvod.nadpis': 'Ruang aman untuk komunitas transgender',
  'uvod.podnadpis': 'Bloom adalah tempat pribadi untuk bicara terbuka, menemukan tenaga profesional yang ramah, '
      + 'dan menjalani transisi di antara orang-orang yang tahu rasanya.',
  'uvod.zdarma': 'Mendaftar gratis. Isi Bloom baru terbuka setelah kamu masuk.',
  'uvod.kCemuJe': 'Bloom itu untuk apa',
  'uvod.kCemuJe1': 'Mencari informasi tentang transisi di Ceko biasanya berarti mengeklik melewati forum '
      + 'yang berserakan, artikel usang, dan tautan yang tidak jelas siapa yang bisa dipercaya. Dan banyak pertanyaan '
      + 'toh paling baik dijawab oleh orang yang pernah menjalaninya sendiri.',
  'uvod.kCemuJe2': 'Bloom menyatukan semuanya di satu tempat: tenaga profesional yang punya rekam jejak baik di komunitas, panduan '
      + 'melewati tahap-tahap transisi, bantuan hukum, dan yang terpenting orang-orang yang bisa kamu ajak bicara.',
  'uvod.kCemuJe3': 'Dan karena ini hal-hal yang tidak ingin diceritakan siapa pun ke seluruh internet, Bloom dibangun sejak '
      + 'awal supaya dari luar tidak terlihat apa-apa sama sekali.',
  'uvod.coNajdes': 'Apa yang akan kamu temukan di Bloom',
  'uvod.coNajdesPopis': 'Delapan bagian yang saling menyambung — dari bantuan praktis sampai pengalaman yang dibagikan.',
  'uvod.soukromiZaklad': 'Privasi bukan tambahan, melainkan dasarnya',
  'uvod.jakZabezpeceny': 'Bagaimana Bloom diamankan',
  'uvod.zabezpeceniPopis': 'Data anggota tidak dijual atau dianalisis di mana pun. Di Bloom tidak ada pelacakan iklan '
      + 'maupun analitik — tidak ada skrip asing yang tahu apa pun tentangmu.',
  'uvod.coNeumi': 'Yang tidak bisa dilakukan Bloom',
  'uvod.metadataTucne': 'siapa menulis kepada siapa dan kapan',
  'uvod.coNeumiA': 'Server selalu tahu',
  'uvod.coNeumiB': ' — tanpa itu ia tidak bisa mengantar pesan. Metadata ini tidak disembunyikan oleh enkripsi ujung ke ujung, '
      + 'dan Signal pun tidak bisa. Profil tidak bisa dienkripsi, karena server harus menampilkannya ke orang lain. '
      + 'Dan karena Bloom adalah aplikasi web, ia mengunduh kode enkripsinya dari server kami setiap kali dibuka — '
      + 'siapa pun yang menguasai server secara teori bisa menyisipkan versi yang diubah. '
      + 'Hanya aplikasi bertanda tangan dari toko yang melindungi dari itu.',
  'uvod.pridejSe': 'Bergabunglah',
  'uvod.pridejSePopis': 'Cukup nama panggilan dan email — kamu tidak perlu menyebutkan nama resmimu di mana pun. Apa yang kamu tulis '
      + 'tentang dirimu terserah kamu, dan bisa diubah atau dihapus kapan saja.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Tawarkan bantuan atau mintalah — dari menemani ke dokter, meminjamkan pakaian, sampai '
      + '«saya perlu bicara dengan seseorang».',
  'uvod.karta.odbornici': 'Seksologi, endokrinologi, bedah, psikoterapi, sampai salon. Lengkap dengan peta, kontak, dan pengalaman orang lain.',
  'uvod.karta.pravo': 'Ganti nama, dokumen resmi, kerja, sekolah. Dijawab oleh orang yang paham betul.',
  'uvod.karta.pruvodce': 'Apa yang menanti di tiap langkah — dari pertanyaan pertama sampai operasi. Dengan tautan ke sumber terverifikasi dan tenaga profesional.',
  'uvod.karta.zpravy': 'Tulis ke siapa pun di komunitas. Pesan dan lampiran tersimpan terenkripsi di server.',
  'uvod.karta.zkusenosti': 'Cerita nyata dari orang yang sudah melewatinya. Tanpa sensor dan tanpa dibagus-baguskan.',
  'uvod.karta.aktuality': 'Apa yang terjadi seputar isu transgender di Ceko — perubahan hukum, acara, kabar komunitas.',
  'uvod.karta.okoli': 'Siapa yang ada di dekatmu. Supaya kamu tahu kamu tidak sendirian, bahkan di kota kecil.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'Dari luar tidak terlihat apa pun',
  'uvod.bezp.zvencinicText': 'Profil, cerita, foto, tawaran, dan gambar di unggahan semuanya butuh masuk. Tanpa akun, '
      + 'server tidak memberikan data apa pun tentang anggota — bahkan ke mesin pencari.',
  'uvod.bezp.hesla': 'Tidak ada yang tahu kata sandimu',
  'uvod.bezp.heslaText': 'Yang disimpan hanya sidik bcrypt, yang tidak bisa dihitung balik menjadi kata sandi asli. Bahkan '
      + 'pengelola tidak melihat kata sandimu dan tidak bisa mengirimkannya — ia hanya bisa membiarkanmu memasang yang baru.',
  'uvod.bezp.sifrovani': 'Pesan terenkripsi dari kamu ke dia',
  'uvod.bezp.sifrovaniText': 'Kalau kamu mengaktifkan enkripsi ujung ke ujung, teks dan lampiran dienkripsi di peramban milikmu sendiri. '
      + 'Kuncinya dibuka dengan kata sandimu dan tidak pernah meninggalkan perangkatmu — server hanya menerima '
      + 'karakter tak terbaca dan tidak bisa membacanya, bahkan kalau pengadilan memintanya. Tanpa enkripsi, pesan setidaknya '
      + 'terenkripsi di disk server.',
  'uvod.bezp.kontakty': 'Kontakmu tetap milikmu',
  'uvod.bezp.kontaktyText': 'Email dan teleponmu tidak pernah diberikan ke anggota lain. Tahap transisimu bersifat pribadi sampai '
      + 'kamu sendiri mempublikasikannya — dan langkah yang kamu centang di Panduan hanya kamu yang melihat.',
  'uvod.bezp.smazane': 'Dihapus berarti benar-benar dihapus',
  'uvod.bezp.smazaneText': 'Kamu bisa menghapus percakapan kapan saja. Kalau kedua belah pihak menghapusnya, ia hilang dari server '
      + 'selamanya, berikut lampirannya.',
  'uvod.bezp.server': 'Server sendiri di Eropa',
  'uvod.bezp.serverText': 'Bloom berjalan di server sendiri di Uni Eropa, hanya lewat HTTPS. Basis datanya tidak bisa dijangkau '
      + 'dari internet. Cadangan dikirim terenkripsi ke penyimpanan lain dan pemulihannya sudah diuji.',

  'uvod.karta.pruvodceNazev': 'Panduan transisi',
  'uvod.karta.zpravyNazev': 'Pesan pribadi',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Tawarkan apa yang kamu bisa dan terima bantuan dari anggota lain di komunitas',
  'pod.vse': 'Semua',
  'pod.nabidky': 'Tawaran',
  'pod.poptavky': 'Permintaan',
  'pod.nabidka': 'Tawaran',
  'pod.poptavka': 'Permintaan',
  'pod.celaCR': 'Seluruh Ceko',
  'pod.celySvet': 'Seluruh dunia',
  'pod.cesko': 'Ceko',
  'pod.svet': 'Dunia',
  'pod.vsechnyTypy': 'Semua kategori',
  'pod.moje': (p) => `Punya saya (${p.pocet})`,
  'pod.pridat': 'Tambah',
  'pod.overEmail': 'Konfirmasi emailmu untuk menambahkan tawaran',
  'pod.novaPoptavka': 'Permintaan baru',
  'pod.novaNabidka': 'Tawaran baru',
  'pod.popisPoptavky': 'Tulis apa yang kamu cari dan apa yang kamu tawarkan sebagai gantinya.',
  'pod.popisNabidky': 'Tawarkan apa yang kamu bisa ke anggota lain di komunitas.',
  'pod.typPrispevku': 'Jenis unggahan',
  'pod.volitelne': '(opsional)',
  'pod.coNabizim': 'Apa yang saya tawarkan',
  'pod.coNabizimP': 'Apa yang saya tawarkan *',
  'pod.coHledamP': 'Apa yang saya cari *',
  'pod.coHledamVymenou': 'Apa yang saya cari sebagai gantinya',
  'pod.priklOffer': 'mis. memasak, potong rambut, terjemahan…',
  'pod.priklNeed': 'mis. pijat, fotografi…',
  'pod.poptavkaSeZobrazi': 'Permintaanmu akan muncul di tab Permintaan.',
  'pod.nabidkaSeZobrazi': 'Kalau kamu mengisinya, tawaranmu juga muncul di tab Permintaan.',
  'pod.popis': 'Deskripsi',
  'pod.popisPriklad': 'Deskripsi yang lebih rinci…',
  'pod.oblast': 'Wilayah',
  'pod.lokalita': 'Lokasi',
  'pod.nechciUvadet': 'Tidak ingin menyebutkan',
  'pod.kategorie': 'Kategori',
  'pod.ostatni': 'Lainnya',
  'pod.pridatPoptavku': 'Tambah permintaan',
  'pod.pridatNabidku': 'Tambah tawaran',
  'pod.odpovedetNaPrispevek': 'Balas unggahan',
  'pod.napisteAutorovi': 'Kirim pesan pribadi ke orang yang mengunggahnya.',
  'pod.od': (p) => `Dari: ${p.kdo}`,
  'pod.odeslatZpravu': 'Kirim pesan',
  'pod.konceptOdpovedi': (p) => `Halo! Saya tertarik dengan ${p.co} «${p.nazev}» kamu. `,
  'pod.konceptPoptavka': 'permintaan',
  'pod.konceptNabidka': 'tawaran',
  'pod.zadneMoje': 'Kamu belum punya unggahan',
  'pod.zadneNalezeny': 'Tidak ada unggahan yang ditemukan',
  'pod.vytvortePrvni': 'Buat tawaran atau permintaan pertamamu',
  'pod.zkusteFiltry': 'Coba ubah filternya atau tambahkan unggahan baru',
  'pod.expirovano': 'Kedaluwarsa',
  'pod.hledam': 'Saya cari',
  'pod.hledamCo': (p) => `Saya cari: ${p.co}`,
  'pod.nabizimCo': (p) => `Saya tawarkan: ${p.co}`,
  'pod.expirovala': 'Tawaran ini sudah kedaluwarsa. Hubungi pengelola untuk memperbaruinya.',
  'pod.odpovedet': 'Balas',
  'pod.upravitPrispevek': 'Ubah unggahan',
  'pod.upravtePrispevek': 'Ubah tawaran atau permintaanmu.',
  'pod.nabizimP': 'Saya tawarkan *',
  'pod.hledamPotrebuji': 'Saya cari / saya butuh',
  'pod.coNabizitePriklad': 'Apa yang kamu tawarkan…',
  'pod.coHledatePriklad': 'Apa yang kamu cari…',
  'pod.ulozitZmeny': 'Simpan perubahan',
  'pod.vytvorenoPoptavka': 'Permintaan dibuat.',
  'pod.vytvorenoNabidka': 'Tawaran dibuat.',
  'pod.chybaVytvorit': 'Unggahan tidak bisa dibuat',
  'pod.opravduSmazat': 'Hapus tawaran ini?',
  'pod.smazano': 'Terhapus',
  'pod.chybaSmazat': 'Tidak bisa dihapus',
  'pod.aktualizovano': 'Unggahan diperbarui.',
  'pod.chybaUlozit': 'Tidak bisa disimpan',
  'pod.zpravaOdeslana': 'Pesan terkirim.',
  'pod.chybaOdeslat': 'Pesan tidak bisa dikirim',
  'obecne.hledatPriklad': 'Cari…',
  'obecne.upravit': 'Ubah',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Temukan tenaga profesional terverifikasi yang bisa membantumu di jalanmu',
  'odb.hledatPriklad': 'Cari berdasarkan nama atau kota…',
  'odb.vsechnyObory': 'Semua bidang',
  'odb.radit': 'Urutkan:',
  'odb.vychozi': 'Bawaan',
  'odb.nejvyssiHodnoceni': '★ Nilai tertinggi',
  'odb.nejnizsiHodnoceni': '★ Nilai terendah',
  'odb.zadniNalezeni': 'Tidak ada tenaga profesional yang ditemukan',
  'odb.zkusteFiltry': 'Coba ubah filternya',
  'odb.recenzi': () => 'ulasan',
  'odb.dostupnyV': 'Tersedia di:',
  'odb.otevritVMapach': 'Buka di peta',
  'odb.pridatRecenzi': 'Tambah ulasan',
  'odb.ohodnotte': 'Beri nilai pengalamanmu dengan orang ini.',
  'odb.vaseHodnoceni': 'Nilaimu *',
  'odb.popisZkusenosti': 'Ceritakan pengalamanmu',
  'odb.popisteZkusenost': 'Ceritakan pengalamanmu…',
  'odb.odeslatRecenzi': 'Kirim ulasan',
  'odb.recenze': (p) => `Ulasan (${p.pocet})`,
  'odb.zadneRecenze': 'Belum ada ulasan. Jadilah yang pertama.',
  'odb.vyberteOdbornika': 'Pilih tenaga profesional untuk melihat detail dan petanya',
  'odb.pridatOdbornika': 'Tambah tenaga profesional',
  'odb.pridejteOdbornika': 'Tambahkan tenaga profesional terverifikasi baru ke daftar.',
  'odb.navrhnout': 'Usulkan tenaga profesional',
  'odb.navrhnetePopis': 'Usulkan tenaga profesional untuk disetujui pengelola.',
  'odb.navrhVysvetleni': 'Usulanmu akan dikirim ke pengelola. Setelah disetujui, ia muncul di daftar.',
  'odb.overEmail': 'Konfirmasi emailmu untuk mengusulkan tenaga profesional',
  'odb.jmeno': 'Nama *',
  'odb.kategorie': 'Kategori *',
  'odb.popis': 'Deskripsi',
  'odb.popisPriklad': 'Spesialisasi, pengalaman…',
  'odb.adresa': 'Alamat *',
  'odb.mesto': 'Kota *',
  'odb.kraj': 'Wilayah',
  'odb.vyber': 'Pilih',
  'odb.stat': 'Negara',
  'odb.cesko': 'Ceko',
  'odb.telefon': 'Telepon',
  'odb.web': 'Situs web',
  'odb.odesilam': 'Mengirim…',
  'odb.odeslatKeSchvaleni': 'Kirim untuk disetujui',
  'odb.recenzePridana': 'Ulasan ditambahkan.',
  'odb.chybaRecenze': 'Ulasan tidak bisa ditambahkan',
  'odb.odeslanKeSchvaleni': 'Usulan sudah dikirim untuk disetujui.',
  'odb.chybaOdeslat': 'Tidak bisa dikirim',
  'odb.pridan': 'Tenaga profesional ditambahkan.',
  'odb.chybaPridat': 'Tidak bisa ditambahkan',
  'odb.polozitOtazku': 'Ajukan pertanyaan',
  'odb.novaOtazka': 'Pertanyaan baru untuk tenaga profesional',
  'odb.naCoSeZeptat': 'Apa yang ingin kamu tanyakan ke tenaga profesional?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Informasi dan dukungan untuk komunitas transgender',
  'prav.zpetNaPoradnu': 'Kembali ke Bantuan hukum',
  'prav.clankyAPruvodci': 'Artikel dan panduan',
  'prav.pridatClanek': 'Tambah artikel',
  'prav.novyClanek': 'Artikel baru',
  'prav.vytvorteClanek': 'Tulis artikel baru untuk bagian hukum.',
  'prav.nazev': 'Judul *',
  'prav.kategorie': 'Kategori',
  'prav.publikovatIhned': 'Terbitkan sekarang',
  'prav.publikovano': 'Terbit',
  'prav.obsah': 'Isi *',
  'prav.obsahPriklad': 'Isi artikel…',
  'prav.zadneClanky': 'Tidak ada artikel di kategori ini',
  'prav.skryto': 'Disembunyikan',
  'prav.skryt': 'Sembunyikan',
  'prav.publikovat': 'Terbitkan',
  'prav.upravitClanek': 'Ubah artikel',
  'prav.upravteObsah': 'Ubah isi artikel ini.',
  'prav.clanekPridan': 'Artikel ditambahkan.',
  'prav.chybaPridat': 'Artikel tidak bisa ditambahkan',
  'prav.clanekUpraven': 'Artikel diperbarui.',
  'prav.opravduSmazat': 'Hapus artikel ini?',
  'prav.chybaStav': 'Status tidak bisa diubah',
  'prav.pridatOtazku': 'Tambah pertanyaan',
  'prav.novaOtazka': 'Pertanyaan baru',
  'prav.naCoSeZeptat': 'Apa yang ingin kamu tanyakan?',
  'obecne.vse': 'Semua',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Kabar dari dunia transgender',
  'akt.prehratVideo': 'Putar video',
  'akt.obrazekVClanku': 'Gambar dalam artikel',
  'akt.clanekNenalezen': 'Artikel tidak ditemukan',
  'akt.zpetNaAktuality': 'Kembali ke berita',
  'akt.autor': (p) => `Penulis: ${p.kdo}`,
  'akt.osobniPribeh': 'Cerita pribadi',
  'akt.upravitClanek': 'Ubah artikel',
  'akt.komentare': (p) => `Komentar (${p.pocet})`,
  'akt.zadneKomentare': 'Belum ada komentar. Jadilah yang pertama.',
  'akt.pridatKomentar': 'Tambah komentar…',
  'akt.proKomentovaniOverte': 'Konfirmasi emailmu untuk berkomentar.',
  'akt.profil': 'Profil',
  'akt.prihlasteSeProKomentovani': 'Masuk untuk berkomentar.',
  'akt.upravteObsah': 'Ubah isi artikel ini.',
  'akt.nadpisP': 'Judul *',
  'akt.nadpis': 'Judul',
  'akt.obsahP': 'Isi *',
  'akt.textClanku': 'Teks artikel…',
  'akt.obrazekUrlNeboSoubor': 'Gambar (alamat atau berkas)',
  'akt.videoUrlNeboSoubor': 'Video (alamat atau berkas)',
  'akt.ukladam': 'Menyimpan…',
  'akt.novaAktualita': 'Berita baru',
  'akt.sdiletPribeh': 'Bagikan cerita',
  'akt.vytvoritAktualitu': 'Tulis berita',
  'akt.sdiletZkusenost': 'Bagikan pengalaman',
  'akt.napisteAktualitu': 'Tulis berita baru untuk komunitas.',
  'akt.podelteSe': 'Bagikan pengalamanmu dengan komunitas.',
  'akt.obrazek': 'Gambar',
  'akt.nahratObrazek': 'Unggah gambar…',
  'akt.nahratVideo': 'Unggah video…',
  'akt.neboUrl': 'atau alamat:',
  'akt.textAktuality': 'Teks berita…',
  'akt.sdilejtePribeh': 'Bagikan cerita atau pengalamanmu dengan komunitas…',
  'akt.nahravam': 'Mengunggah…',
  'akt.publikovat': 'Terbitkan',
  'akt.zkusenostiTucne': 'Pengalaman pribadi anggota komunitas.',
  'akt.zkusenostiPopis': 'Bagian ini untuk berbagi pengalaman hidup dan cerita. Unggahan boleh berisi teks, gambar, atau video.',
  'akt.sdiletSvujPribeh': 'Bagikan ceritaku',
  'akt.zadneAktuality': 'Tidak ada berita',
  'akt.zadneVKategorii': 'Belum ada apa-apa di kategori ini',
  'akt.publikovan': 'Unggahan diterbitkan.',
  'akt.chybaPublikovat': 'Tidak bisa diterbitkan',
  'akt.opravduSmazat': 'Hapus unggahan ini?',
  'akt.chyba': 'Ada yang tidak beres',
  'akt.chybaKomentar': 'Komentar tidak bisa ditambahkan',
  'akt.chybaSmazatKomentar': 'Komentar tidak bisa dihapus',
  'akt.aktualizovan': 'Unggahan diperbarui.',
  'obecne.smazat': 'Hapus',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Saya sedang memikirkan transisi',
  'faze.thinking.popis': 'Saya sedang mencari tahu siapa saya dan jalan mana yang jadi milik saya.',
  'faze.research': 'Saya sedang mencari informasi',
  'faze.research.popis': 'Saya membaca, bertanya, mencari sumber dan komunitas.',
  'faze.therapist': 'Kunjungan pertama ke terapis',
  'faze.therapist.popis': 'Saya membicarakan jalan saya dengan tenaga profesional.',
  'faze.hormones': 'Terapi hormon',
  'faze.hormones.popis': 'Saya memulai atau melanjutkan terapi hormon.',
  'faze.documents': 'Mengubah dokumen',
  'faze.documents.popis': 'Saya sedang mengurus perubahan nama atau gender secara resmi.',
  'faze.cosmetic': 'Penampilan dan perawatan',
  'faze.cosmetic.popis': 'Saya menggarap penampilan saya – rambut, riasan, gaya.',
  'faze.surgery-thinking': 'Saya sedang mempertimbangkan operasi',
  'faze.surgery-thinking.popis': 'Saya sedang menimbang pilihan-pilihan operasi.',
  'faze.surgery': 'Setelah operasi',
  'faze.surgery.popis': 'Saya sudah menjalani satu atau lebih operasi.',
  'faze.stable': 'Tahap stabil',
  'faze.stable.popis': 'Saya sudah di tempat yang saya mau, dan menjalani hidup saya.',
  'faze.individual': 'Jalan saya sendiri',
  'faze.individual.popis': 'Jalan saya tidak masuk kotak mana pun – dan itu tidak apa-apa.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'Di sinilah cerita dibagikan.',
  'zk.pribehNenalezen': 'Cerita tidak ditemukan',
  'zk.zpetNaPribehy': 'Kembali ke cerita',
  'zk.komunita': 'Komunitas',
  'zk.pribeh': 'Cerita',
  'zk.upravitPribeh': 'Ubah cerita',
  'zk.upravtePribeh': 'Ubah cerita yang kamu bagikan.',
  'zk.textPribehu': 'Teks cerita…',
  'zk.fazeTranzice': 'Tahap transisi',
  'zk.neuvadet': 'Tidak disebutkan',
  'zk.ukazeSeLidem': 'Cerita akan ditampilkan ke orang yang membaca panduan untuk tahap itu.',
  'zk.sdiletPribeh': 'Bagikan cerita',
  'zk.overEmail': 'Konfirmasi emailmu untuk membagikan cerita',
  'zk.zadnePribehy': 'Belum ada cerita. Jadilah yang pertama.',
  'zk.nazevPribehu': 'Judul ceritamu…',
  'zk.pribehP': 'Cerita *',
  'zk.sdilejteZkusenost': 'Bagikan pengalamanmu dengan komunitas…',
  'zk.chybaNacist': 'Cerita tidak bisa dimuat',
  'zk.vyplnteNadpis': 'Isi judul dan teksnya',
  'zk.spatnyOdkaz': 'Tautan gambar harus diawali http://, https:// atau /',
  'zk.sdilen': 'Cerita dibagikan.',
  'zk.chybaSdilet': 'Tidak bisa dibagikan',
  'zk.opravduSmazat': 'Hapus cerita ini?',
  'zk.smazan': 'Cerita dihapus',
  'zk.aktualizovan': 'Cerita diperbarui.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Emailmu belum dikonfirmasi. Tolong konfirmasi.',
  'ram.odesilam': 'Mengirim…',
  'ram.znovuOdeslat': 'Kirim ulang',
  'ram.chceteUpozorneni': 'Mau dapat notifikasi untuk pesan baru?',
  'ram.tedNe': 'Nanti saja',
  'ram.paticka': '© 2026 Bloom – ruang pribadi untuk komunitas transgender',
  'ram.zasadyKomunity': 'Aturan komunitas',
  'ram.prekladNeovereny': 'Terjemahan ini belum dibaca orang yang berbahasa ini. Kalau ada yang terdengar janggal, beri tahu kami.',
  'ram.nahlasitProblem': 'Laporkan masalah',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Pengelola',
  'ot.overenyPravnik': 'Ahli hukum terverifikasi',
  'ot.overenyOdbornik': 'Tenaga profesional terverifikasi',
  'ot.odznakJinaZeme': (p) => `Lencana ini hanya berlaku untuk: ${p.zeme}`,
  'ot.otazkyKomunity': 'Pertanyaan komunitas',
  'ot.pridatOtazku': 'Tambah pertanyaan',
  'ot.novaOtazka': 'Pertanyaan baru',
  'ot.naCoSeZeptat': 'Apa yang ingin kamu tanyakan?',
  'ot.otazkaSeZobrazi': 'Pertanyaanmu akan dilihat anggota lain di komunitas, dan mereka bisa menjawabnya.',
  'ot.otazkaP': 'Pertanyaan *',
  'ot.oblastTema': 'Bidang / tema',
  'ot.vseObecna': 'Apa saja (pertanyaan umum)',
  'ot.odeslatOtazku': 'Kirim pertanyaan',
  'ot.overEmail': 'Konfirmasi emailmu untuk bertanya',
  'ot.zadneOtazky': 'Belum ada pertanyaan. Jadilah yang pertama.',
  'ot.hlasu': () => 'suara',
  'ot.odpovedi': () => 'jawaban',
  'ot.zadneOdpovedi': 'Belum ada jawaban.',
  'ot.napisteOdpoved': 'Tulis jawaban…',
  'ot.jenPravnici': 'Pertanyaan di Bantuan hukum dijawab oleh ahli hukum terverifikasi dan pengelola.',
  'ot.smazatOtazku': 'Hapus pertanyaan ini?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Tawaran dan permintaan',
  'cp.zadneNabidky': 'Tidak ada tawaran',
  'cp.napsatZpravu': 'Tulis pesan',
  'cp.nahlasitUzivatele': 'Laporkan orang ini',
  'cp.nahlasitKoho': (p) => `Laporkan: ${p.kdo}`,
  'cp.popisteDuvod': 'Jelaskan kenapa kamu melapor. Pengelola akan melihat laporan ini.',
  'cp.zustaneteAnonymni': 'Laporan diterima pengelola. Kamu tetap anonim.',
  'cp.duvodP': 'Alasan *',
  'cp.vybertDuvod': 'Pilih alasan…',
  'cp.nevhodneChovani': 'Perilaku tidak pantas',
  'cp.falesnyProfil': 'Profil palsu',
  'cp.jinyProblem': 'Masalah lain',
  'cp.popisVolitelny': 'Deskripsi',
  'cp.volitelny': '(opsional)',
  'cp.popisteSituaci': 'Jelaskan situasinya lebih rinci…',
  'cp.odeslatNahlaseni': 'Kirim laporan',
  'cp.vyberteDuvodChyba': 'Pilih alasan pelaporan',
  'cp.nahlaseniOdeslano': 'Laporan sudah dikirim ke pengelola',
  'cp.chybaNahlaseni': 'Laporan tidak bisa dikirim',
  'gal.chranenoHeslem': 'Dilindungi kata sandi',
  'gal.soukromi': 'Privasi',
  'gal.nahravam': 'Mengunggah…',
  'gal.pridatFotku': 'Tambah foto',
  'gal.nastaveniSoukromi': 'Privasi galeri',
  'gal.verejna': 'Publik',
  'gal.chranenaHeslem': 'Dilindungi kata sandi',
  'gal.nastaveniUlozeno': 'Pengaturan galeri tersimpan',
  'gal.jeChranena': 'Galeri ini dilindungi kata sandi',
  'gal.zadneFotky': 'Belum ada foto. Tambahkan yang pertama.',
  'gal.otagovat': 'Tandai seseorang',
  'gal.hledatUzivatele': 'Cari orang…',
  'gal.odemcena': 'Galeri terbuka',
  'gal.spatneHeslo': 'Kata sandi galeri salah',
  'gal.fotkaNahrana': 'Foto terunggah.',
  'gal.chybaNahrat': 'Foto tidak bisa diunggah',
  'gal.fotkaSmazana': 'Foto dihapus',
  'gal.jizOtagovan': 'Orang itu sudah ditandai',
  'gal.otagovan': (p) => `Ditandai: ${p.kdo}`,
  'gal.chybaTag': 'Penandaan tidak bisa ditambahkan',
  'gal.soukromiGalerie': 'Privasi galeri',
  'gal.verejnaGalerie': 'Galeri publik',

  'ram.povolit': 'Izinkan',
  'ram.oProjektu': 'Tentang proyek',
  'ram.kontakt': 'Kontak',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Peta dunia – klik sebuah negara untuk membukanya',
  'mapa.priblizit': 'Perbesar',
  'mapa.oddalit': 'Perkecil',
  'mapa.celySvet': 'Kembali ke seluruh dunia',
  'mapa.chybaNacteni': 'Peta tidak bisa dimuat',
  'mapa.chybaZkusteSeznam': 'Peta tidak bisa dimuat. Coba daftar negara di bawah.',
  'mapa.teprveRoste': 'Bloom baru mulai di sini',
  'mapa.napovedaDotyk': 'Seret untuk menggeser peta; perbesar dengan cubitan, ketuk dua kali, atau lewat tombol. Kamu tidak harus memakainya — di bawah ada pencarian dan daftar lengkap negara.',
  'obsah.specialists': () => 'tenaga profesional',
  'obsah.organizations': () => 'organisasi',
  'obsah.events': () => 'acara',
  'obsah.pageants': () => 'kontes',
  'obsah.resources': () => 'sumber',
  'obsah.zaznamu': (p) => `${p.pocet} entri`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Di mana rumahmu?',
  'domov.popis': 'Dengan begitu Bloom menampilkan yang dekat denganmu. Kamu boleh menjelajah negara mana saja — itu tidak '
      + 'mengubah negara tempatmu tinggal. Ini tidak dipublikasikan di mana pun dan bisa diubah kapan saja.',
  'domov.preskocit': 'Lewati',
  'domov.najitZemi': 'Cari negara…',
  'domov.nicNeodpovida': 'Tidak ada yang cocok. Coba pencarian lain.',
  'domov.klikniDoMapy': 'Kamu juga bisa langsung mengeklik negara di peta di atas.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Unggahan',
  'typ.users': 'Orang',
  'typ.specialists': 'Tenaga profesional',
  'typ.services': 'Tawaran',
  'typ.articles': 'Bantuan hukum',
  'typ.questions': 'Pertanyaan komunitas',
  'typ.reviews': 'Ulasan tenaga profesional',
  'nav.emailNeoveren': 'Email belum dikonfirmasi',
  'nav.neovereny': 'Belum dikonfirmasi',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'Ada yang tidak berfungsi',
  'chyba.navrh': 'Usulan perbaikan',
  'chyba.bezpecnost': 'Masalah keamanan',
  'chyba.jiny': 'Hal lain',
  'chyba.vyberteTyp': 'Pilih jenis masalahnya',
  'chyba.popisteProsim': 'Jelaskan masalahnya',
  'chyba.odeslano': 'Laporan terkirim, terima kasih!',
  'chyba.chybaOdeslat': 'Laporan tidak bisa dikirim',
  'chyba.napisteNam': 'Ceritakan apa yang terjadi — itu membantu kami memperbaikinya.',
  'chyba.typProblemu': 'Jenis masalah',
  'chyba.popisProblemu': 'Apa yang terjadi',
  'chyba.popisPriklad': 'Ceritakan apa yang terjadi, apa yang kamu harapkan, dan apa yang terjadi malah…',
  'chyba.priloha': 'Kami lampirkan otomatis: halaman saat ini, waktu, dan info tentang peramban kamu.',
  'chyba.odeslatHlaseni': 'Kirim laporan',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Tulis isinya…',
  'ed.tucne': 'Tebal (Ctrl+B)',
  'ed.kurziva': 'Miring (Ctrl+I)',
  'ed.odrazky': 'Daftar berpoin',
  'ed.vlozitOdkaz': 'Sisipkan tautan',
  'ed.vlozitTabulku': 'Sisipkan tabel',
  'ed.radky': 'Baris',
  'ed.sloupce': 'Kolom',
  'ed.vlozit': 'Sisipkan',
  'ed.barva.cerna': 'Hitam',
  'ed.barva.seda': 'Abu-abu',
  'ed.barva.fialova': 'Ungu',
  'ed.barva.ruzova': 'Merah muda',
  'ed.barva.modra': 'Biru',
  'ed.barva.zelena': 'Hijau',
  'ed.barva.cervena': 'Merah',
  'ed.barva.oranzova': 'Oranye',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Tautan konfirmasi itu tidak berlaku.',
  'over.hotovo': 'Emailmu sudah dikonfirmasi.',
  'over.odkazVyprsel': 'Tautan konfirmasinya tidak berlaku atau sudah kedaluwarsa.',
  'over.overuji': 'Mengonfirmasi email…',
  'over.cekejte': 'Tunggu sebentar.',
  'over.overen': 'Email dikonfirmasi.',
  'over.plnyPristup': 'Sekarang kamu punya akses penuh ke semua di Bloom.',
  'over.prejitNaBloom': 'Ke Bloom',
  'over.selhalo': 'Konfirmasi gagal',
  'over.zpetNaPrihlaseni': 'Kembali ke halaman masuk',
  'oauth.ucetNenalezen': 'Akun tidak ditemukan',
  'oauth.neexistujeGoogle': 'Tidak ada akun Bloom untuk akun Google ini. Daftar dulu.',
  'oauth.neexistujeFacebook': 'Tidak ada akun Bloom untuk akun Facebook ini. Daftar dulu.',
  'oauth.registrovatGoogle': 'Daftar dengan Google',
  'oauth.registrovatFacebook': 'Daftar dengan Facebook',
  'oauth.prihlasujiGoogle': 'Masuk dengan Google…',
  'oauth.prihlasujiFacebook': 'Masuk dengan Facebook…',
  'oauth.facebookSelhalo': 'Masuk dengan Facebook gagal',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Memuat…',
  'obecne.nezadano': '— tidak diisi —',
  'obecne.neplatnaHodnota': 'Nilai itu tidak berlaku.',
  'obecne.strankovani': 'Penomoran halaman',
  'navrh.doplnteNazev': 'Isi namanya.',
  'navrh.vyberteZemi': 'Pilih negaranya.',
  'navrh.doplnte': (p) => `Isi: ${p.co}.`,
  'kat.overenoZaznam': 'Sudah diperiksa bahwa entri ini sesuai kenyataan',
  'kat.prihlaskyDo': (p) => `Pendaftaran sampai ${p.datum}`,

  'up.odznakAdmin': 'Admin',

  'profil.zalozkaProfil': 'Profil',
  'profil.zalozkaGalerie': 'Galeri',
  'pf.lokalita': 'Lokasi',

  'cesta.legendaBarev': 'Keterangan warna',

  'hled.pocetVysledku': (p) => `(${p.pocet} hasil)`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Rambut pirang panjang',
  'avatar.fem-lavender': 'Rambut ungu',
  'avatar.fem-peach': 'Bob berponi',
  'avatar.fem-dark': 'Rambut gelap panjang',
  'avatar.fem-straight': 'Rambut merah',
  'avatar.fem-ponytail': 'Ekor kuda',
  'avatar.masc-blue': 'Rambut pirang pendek',
  'avatar.masc-teal': 'Rambut acak-acakan',
  'avatar.masc-gray': 'Rambut beruban',
  'avatar.masc-short': 'Cepak',
  'avatar.nb-mint': 'Rambut hijau mint',
  'avatar.nb-lilac': 'Sanggul tinggi',
  'avatar.nb-curly': 'Ikal pendek',
  'avatar.nb-sage': 'Rambut sebahu',
  'avatar.nb-mohawk': 'Mohawk',
  'avatar.nb-undercut': 'Undercut',
  'avatar.nb-shaved': 'Kepala dicukur',
  'avatar.nb-glasses': 'Kacamata',
  'avatar.animal-cat': 'Kucing',
  'avatar.animal-fox': 'Rubah',
  'avatar.animal-rabbit': 'Kelinci',
  'avatar.sym-flower': 'Bunga',
  'avatar.sym-butterfly': 'Kupu-kupu',
  'avatar.sym-star': 'Bintang',
  'avatar.custom': 'Unggah fotoku sendiri',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Kami mengeluarkanmu setelah beberapa saat tanpa aktivitas.',
  'odhl.necinnostPopis': 'Bloom tidak membiarkan sesi terbuka kalau tidak ada siapa-siapa.',
  'odhl.zaChvili': 'Sebentar lagi kami keluarkan kamu',
  'odhl.zaChviliPopis': 'Sentuh layar atau keyboard kapan saja dan kamu tetap masuk.',

  'reg.avatarSymboly': 'Simbol',

  'avatar.fem-bun': 'Sanggul',
  'avatar.masc-navy': 'Janggut penuh',
  'avatar.masc-brown': 'Belah samping',
  'avatar.masc-goatee': 'Janggut kambing',
  'avatar.nb-freckles': 'Bintik-bintik',
  'avatar.animal-panda': 'Panda',
  'avatar.animal-owl': 'Burung hantu',
  'avatar.sym-rainbow': 'Pelangi',
  'avatar.sym-heart': 'Hati',
  'avatar.sym-lotus': 'Teratai (Bloom)',

  'reg.potvrditHeslo': 'Konfirmasi kata sandi',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Buat',
  'obecne.sdilet': 'Bagikan',
  'obecne.opravneni': 'Izin',
  'obecne.pristupGalerie': 'Kami butuh akses ke galeri untuk mengunggah foto.',
  'obecne.vsechnyRegiony': 'Semua wilayah',
  'obecne.cesko': 'Ceko',
  'obecne.odbornici': 'Profesional',
  'obecne.zadnaZprava': 'Belum ada pesan',
  'ucet.vyplnteEmailHeslo': 'Masukkan e-mail dan kata sandi',
  'ucet.spatneUdaje': 'E-mail atau kata sandi salah',
  'ucet.googleSelhalo': 'Masuk dengan Google gagal',
  'ucet.skrytHeslo': 'Sembunyikan kata sandi',
  'ucet.emailOveren': 'E-mail kamu sudah terverifikasi.',
  'ucet.emailPriklad': 'kamu@email.com',
  'ucet.overeniSelhalo': 'Verifikasi gagal.',
  'ucet.overeniSelhaloZnovu': 'Verifikasi gagal. Coba lagi.',
  'ucet.komunitniHesloPovinne': 'Kata sandi komunitas wajib diisi',
  'ucet.zadejteKomunitniHeslo': 'Masukkan kata sandi komunitas…',
  'ucet.komunitniHesloPopis': 'Bloom adalah ruang privat. Seseorang dari komunitas bisa memberimu kata sandinya.',
  'ucet.prezdivkaMin3': 'Nama tampilan minimal 3 karakter',
  'ucet.vyplntePrezdivku': 'Masukkan nama tampilan',
  'ucet.vasePrezdivka': 'Nama tampilanmu',
  'ucet.profilNeulozen': 'Gagal menyimpan profil',
  'ucet.anoZrusitProfil': 'Ya, hapus profil saya',
  'heslo.min8': 'Kata sandi minimal 8 karakter',
  'heslo.maleP': 'Kata sandi harus memuat huruf kecil',
  'heslo.velkeP': 'Kata sandi harus memuat huruf besar',
  'heslo.cislo': 'Kata sandi harus memuat angka',
  'heslo.specialni': 'Kata sandi harus memuat karakter khusus',
  'heslo.specialniPriklad': 'Kata sandi harus memuat karakter khusus (!@#$%)',
  'heslo.napoveda': 'Min. 8 karakter, huruf besar, angka, karakter khusus',
  'profil.oSobe': 'Sedikit tentang kamu…',
  'profil.zajmenaOna': 'dia (perempuan)',
  'profil.zajmenaJine': 'lainnya',
  'profil.doplnujiciText': 'Catatan tambahan (opsional)…',
  'profil.prikladOboru': 'mis. bedah plastik, hukum keluarga…',
  'komunita.soukromiNadpis': 'Kami menjaga privasi',
  'komunita.soukromiText': 'Apa yang dibagikan di Bloom tetap di Bloom.',
  'komunita.podporaText': 'Bloom adalah tentang saling mendukung.',
  'komunita.neniObchod': 'Bloom bukan platform jual beli.',
  'komunita.zadneObtezovani': 'Pelecehan dalam bentuk apa pun tidak diterima di Bloom.',
  'komunita.oslovovani': 'Kami menyapa setiap orang dengan nama dan kata ganti yang mereka pakai.',
  'komunita.jakakolivEtapa': 'Di mana pun kamu berada dalam perjalananmu.',
  'prav.kategZdravi': 'Kesehatan',
  'prav.kategPravni': 'Hukum',
  'prav.kategSocialni': 'Sosial',
  'ot.chybaOdpoved': 'Gagal mengirim jawaban.',
  'ot.chybaOtazka': 'Gagal menambahkan pertanyaan.',
  'zk.napisteKomentar': 'Tulis komentar…',
  'zpr.chybaHlasova': 'Gagal mengunggah pesan suara. Server:',
  'zpr.chybaObrazek': 'Gagal mengunggah gambar. Server:',
  'pod.nabizim': 'Menawarkan',
  'pod.coHledate': 'Kamu mencari apa? (mis. pijat, fotografi…)',
  'pod.coNabizite': 'Kamu menawarkan apa? (mis. masak, tata rambut…)',
  'pod.lokalitaVolitelna': 'Lokasi (opsional)',
  'pod.podrobnejsiPopis': 'Deskripsi lebih rinci *',
  'pod.vyplnteHledate': 'Tulis apa yang kamu cari.',
  'pod.vyplnteNabizite': 'Tulis apa yang kamu tawarkan.',
  'pod.vyplntePopis': 'Tambahkan deskripsi.',
  'pod.zadnePrispevky': 'Kamu belum punya postingan. Buat penawaran atau permintaan.',
  'svet.vybratZemi': 'Pilih negara',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Ajukan pertanyaan',
  'ot.nadpis': 'Tanya jawab',
  'zk.pridat': 'Tambahkan cerita',
  'zk.novy': 'Cerita baru',
  'zk.smazat': 'Hapus cerita',
  'zk.zadne': 'Belum ada cerita. Jadilah yang pertama berbagi.',
  'akt.zadne': 'Belum ada berita.',
  'nav.clanky': 'Artikel',
  'ucet.emailOdeslan': 'E-mail terkirim',
  'ucet.komunitniHeslo': 'Kata sandi komunitas',
  'ucet.nemateUcet': 'Belum punya akun? Daftar',
  'ucet.muzetePrihlasit': 'Sekarang kamu bisa masuk.',
  'ucet.zapomenutePopis': 'Masukkan e-mail dan kami akan mengirim tautan untuk mengatur ulang kata sandi.',
  'profil.oMneVolitelne': 'Tentang saya (opsional)',
  'profil.prezdivka': 'Nama tampilan',
  'profil.telefonVolitelne': 'Telepon (opsional)',
  'cesta.poznamkaVolitelna': 'Catatan pribadi (opsional)',
  'okoli.vyberteLokalitu': 'Pilih lokasi di atas',
  'hled.nadpis': 'Pencarian',
  'hled.popis': 'Cari di seluruh aplikasi – orang, artikel, cerita, ulasan…',
  'hled.min2': 'Ketik minimal 2 karakter untuk mencari',
  'pod.vsechnySluzby': 'Semua layanan',
  'domu.clenoveKomunity': 'Anggota komunitas',
  'zpr.zadneKonverzaceHledat': 'Belum ada percakapan. Cari seseorang di atas.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'dia (laki-laki)',
  'reg.zajmenaOni': 'mereka',
  'reg.zajmenaOno': '-nya',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Hapus foto',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Atur kata sandi untuk galeri',
  'reg.min3znaky': 'Min. 3 karakter',
  'reg.zopakujteHeslo': 'Ulangi kata sandi',
  'hled.vBloom': 'Cari di Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Ubah profil',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Pilih wilayah',
  'obecne.region': 'Wilayah',
  'gal.heslemChranena': 'Dilindungi kata sandi',
  'gal.hesloGalerie': 'Kata sandi galeri',
  'reset.nastavitHeslo': 'Atur kata sandi',
  'reset.hesloObnoveno': 'Kata sandi berhasil diatur ulang.',
  'profil.nenalezen': 'Profil tidak ditemukan',
  'obecne.nebo': 'atau',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Buka aplikasi kode otentikasi dan salin enam digit untuk Bloom. Kamu juga bisa memakai salah satu kode cadangan.',
  'auth.sifrovaniNapoveda': 'Kalau kamu mengaktifkan enkripsi pesan di web, aplikasi belum bisa masuk ke akun itu. Gunakan bloomapp.cz di peramban.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Tampilkan kata sandi',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Hapus foto ini?',
  'dvf.zadejteKod': 'Masukkan kode dari aplikasimu',
  'sif.odemknoutAplikaci': 'Buka kunci aplikasi',
  'profil.odeslatZnovu': 'Kirim lagi',
};

export default id;
